
function I(name){ return (window.IMAGES && window.IMAGES[name]) || ""; }
function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
var MAPS_URL = 'https://www.google.com/maps/place/Afrofix+Egypt/@29.9100154,30.8781866,663m/data=!3m2!1e3!4b1!4m6!3m5!1s0x1458ff009fc441e1:0x56aef9f97af79895!8m2!3d29.9100108!4d30.8807615!16s%2Fg%2F11q4jtrh6r';
var PIN_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex:none"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path><circle cx="12" cy="10" r="3"></circle></svg>';
var ARROW_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>';

/* Moments of Pride — the routed wave. Every cubic segment lands on its node
   with a horizontal tangent, so each ring sits flat on the line. Node x values
   below match the path's four turning points exactly. */
var MOP_X = ['14%','38%','62%','86%'];
var MOP_D = 'M0 26 C5 26,9 13,14 13 C20 13,32 28.5,38 28.5 C44 28.5,56 13,62 13 C68 13,80 28.5,86 28.5 C91 28.5,96 21,100 21';
var MOP_ROUTE_M = '<svg class="mop-route-m" aria-hidden="true" preserveAspectRatio="none">'
  +'<defs><filter id="mopMGlow" x="-30%" y="-6%" width="160%" height="112%">'
  +'<feGaussianBlur stdDeviation="3" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>'
  +'<path class="rm-guide" d=""/><path class="rm-live" d="" filter="url(#mopMGlow)"/><g class="rm-dots"></g></svg>';

var MOP_ROUTE = '<svg class="mop-route" viewBox="0 0 100 40" preserveAspectRatio="none" aria-hidden="true">'
 +'<defs><linearGradient id="mopGrad" x1="0" y1="0" x2="1" y2="0">'
 +'<stop class="s-end" offset="0"/><stop class="s-mid" offset=".5"/><stop class="s-end" offset="1"/>'
 +'</linearGradient>'
 +'<filter id="mopGlow" x="-20%" y="-60%" width="140%" height="220%">'
 +'<feGaussianBlur stdDeviation="1.1" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>'
 +'</filter></defs>'
 +'<path class="guide" d="'+MOP_D+'"/>'
 +'<path id="mopLive" class="live" pathLength="100" filter="url(#mopGlow)" d="'+MOP_D+'"/>'
 +'<circle class="pulse" cx="0" cy="0" r="0.32">'
 +'<animateMotion dur="7s" repeatCount="indefinite" rotate="auto">'
 +'<mpath href="#mopLive" xlink:href="#mopLive"/></animateMotion></circle>'
 +'</svg>';
var MOP_HEX = '<svg class="hex" viewBox="0 0 400 360" fill="none" aria-hidden="true">'
 +'<path d="M200 8 L392 118 L392 242 L200 352 L8 242 L8 118 Z" stroke="currentColor" stroke-width="1"/>'
 +'<path d="M200 70 L338 150 L338 210 L200 290 L62 210 L62 150 Z" stroke="currentColor" stroke-width="1" opacity=".6"/>'
 +'</svg>';


var CHEV = {
  prev:'<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>',
  next:'<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>'
};

/* Hero slides are finished artwork: the headline, body copy and buttons are
   part of each image, so the alt text carries the meaning for screen readers
   and the whole slide links through to Solutions. */
var HERO_ARROW = '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>';

var HERO_SLIDES = [
 {
  "img": "hero2-01.webp",
  "en": "AFROFIX pipe support range",
  "kicker": "MEP support solutions",
  "h": [
   "Engineered for",
   "every connection."
  ],
  "acc": 1,
  "sub": "Manufactured support systems for industrial, commercial and utility installations.",
  "spec": "Pipe supports • Structural attachments • Channel systems",
  "pl": "View the range",
  "href": "/collections",
  "sl": "Ask for a quotation"
 },
 {
  "img": "hero2-02.webp",
  "en": "Pipe clamps, hangers, beam clamps, U-bolts and channels by AFROFIX",
  "kicker": "AFROFIX support systems",
  "h": [
   "Complete support.",
   "One source."
  ],
  "sub": "A coordinated range of pipe clamps, hangers, beam clamps, U-bolts, channels and accessories for electromechanical installations.",
  "spec": "Egyptian manufacturing since 1981",
  "pl": "Explore products",
  "href": "/collections/electromechanical-supports",
  "sl": "Request a quotation"
 },
 {
  "img": "hero2-03.webp",
  "en": "DSM pipe clamp with PVC lining",
  "kicker": "DSM pipe clamp with PVC lining",
  "h": [
   "Quiet support.",
   "Precise installation."
  ],
  "sub": "For supporting vertical or horizontal pipelines, with PVC lining for noise insulation.",
  "spec": "Zinc plated or hot-dip galvanized",
  "pl": "Explore pipe clamps",
  "href": "/products/dsm-pipe-clamp",
  "sl": "Request a quotation"
 },
 {
  "img": "hero2-04.webp",
  "en": "Standard U-bolt and U-bolt with PVC hose",
  "kicker": "Standard U-bolt systems",
  "h": [
   "Fix. Support.",
   "Guide."
  ],
  "sub": "For fixing, supporting or guiding pipes to support elements and channels.",
  "spec": "MSS SP-58 Type 24 — size conditions apply",
  "pl": "View U-bolts",
  "href": "/products/u-bolt",
  "sl": "Request a quotation"
 },
 {
  "img": "hero2-05.webp",
  "en": "Beam clamp types A and B",
  "kicker": "Beam clamp types A & B",
  "h": [
   "Secure vertical",
   "rod connections."
  ],
  "sub": "For attaching vertical threaded rods to structural beam flanges.",
  "spec": "MSS SP-58 Type 19 • Design load 2.35 kN",
  "pl": "View beam clamps",
  "href": "/collections/steel-structure-support",
  "sl": "Request a quotation"
 },
 {
  "img": "hero2-06.webp",
  "en": "Standard clevis hanger, UL Listed and FM Approved",
  "kicker": "Standard clevis hanger",
  "h": [
   "Adjustable support",
   "for horizontal pipes."
  ],
  "sub": "For insulated and non-insulated horizontal pipes, with vertical adjustment and up to 15° swing in either direction.",
  "spec": "UL Listed: 3/4″–10″ • FM Approved: 3/4″–4″",
  "pl": "View clevis hangers",
  "href": "/products/clevis-hanger-ul-fm",
  "sl": "Request a quotation"
 },
 {
  "img": "hero2-07.webp",
  "en": "Standard riser clamp",
  "kicker": "Standard riser clamp",
  "h": [
   "Stability for",
   "vertical pipe runs."
  ],
  "sub": "Designed to support and stabilize vertical pipe runs, with long wings that transfer the riser load to the floor or ceiling.",
  "spec": "FM Approved sizes: 2″–8″ only",
  "pl": "View riser clamps",
  "href": "/products/riser-clamp-fm",
  "sl": "Request a quotation"
 },
 {
  "img": "hero2-08.webp",
  "en": "Offset pipe clamp",
  "kicker": "Offset pipe clamp",
  "h": [
   "Defined clearance.",
   "Secure support."
  ],
  "sub": "For supporting pipelines at a defined distance from the wall or floor.",
  "spec": "Custom offset available • Not for use as a riser clamp",
  "pl": "View pipe supports",
  "href": "/products/offset-pipe-clamp",
  "sl": "Request a quotation"
 },
 {
  "img": "hero2-09.webp",
  "en": "Beam clamp for SAM strut channels",
  "kicker": "Beam clamp for SAM strut channels",
  "h": [
   "Faster structural",
   "attachment."
  ],
  "sub": "For attaching SAM strut channels to structural beam flanges.",
  "spec": "Designed to be used in pairs",
  "pl": "View structural attachments",
  "href": "/products/beam-clamp-for-sam-strut-channel",
  "sl": "Request a quotation"
 },
 {
  "img": "hero2-10.webp",
  "en": "Flat-bottom insulation wood frame",
  "kicker": "Flat-bottom insulation wood frame",
  "h": [
   "Protect the",
   "insulation."
  ],
  "sub": "Designed to prevent crushing of pipe insulation at the point of support.",
  "spec": "Custom insulation thickness available",
  "pl": "View insulation supports",
  "href": "/products/wooden-support",
  "sl": "Request a quotation"
 }
];

var LOGO = {
  'Orascom':'firm-orascom.png','The Arab Contractors':'firm-arab-contractors.png',
  'Consolidated Contractors (CCC)':'firm-ccc.png','Hassan Allam Construction':'firm-hassan-allam.png',
  'Elsewedy Electric':'firm-elsewedy.png','CSCEC':'firm-cscec.png','Concord':'firm-concord.png',
  'GAMA Construction':'firm-gama.png','Redcon':'firm-redcon.png',
  'DAR':'firm-dar.png','Hill International':'firm-hill.png','Systra':'firm-systra.png',
  'ECG':'firm-ecg.png','ACE Moharram Bakhoum':'firm-ace.png','Sabbour':'firm-sabbour.png',
  'EHAF':'firm-ehaf.png','SHAKER':'firm-shaker.png','Raafat Miller Consulting':'firm-rmc.png',
  'Zuhair Fayez Partnership':'firm-zuhair-fayez.png'
};

var BASE = {
  en: { nav:{home:'Home',products:'Solutions',projects:'Projects',certs:'Certificates',about:'About',contractors:'Contractors',consultants:'Consultants',contact:'Contact us'},
        cta:{quote:'Ask for a quotation', quoteShort:'Get a quote'},
        footer:{tag:'The African Company for Trading & Engineering', company:'AFROFIX — All rights reserved.', exploreHead:'Explore', contactHead:'Contact', addr:'Plot No. 132 — 6th Industrial Zone Extension, 6th of October City, Egypt'} }
};

var HOME = {
  en:{
    hero:{kicker:'Egypt · MEP support systems', title:'Your reliable MEP support partner.', sub:'AFROFIX is the first Egyptian manufacturer of electro-mechanical support systems — engineered, load-rated and certified for industrial, commercial and utility installations.', since:'Since 1981', explore:'Explore solutions'},
    stats:[{num:'40+',label:'Years manufacturing'},{num:'6',label:'Solution categories'},{num:'UL · FM',label:'Certified products'},{num:'60+',label:'Landmark projects'}],
    solHead:{kicker:'Solutions', title:'Six solutions, one standard.', viewAll:'All solutions'},
    products:[
      {name:'Fire Fighting',tag:'UL \u00b7 FM certified',img:'cover-fire-fighting.jpg',cover:true,desc:'UL Listed and FM Approved clevis hangers, band hangers and riser clamps for sprinkler and fire-protection piping.'},
      {name:'HVAC',tag:'Mechanical',img:'cover-hvac.jpg',cover:true,desc:'Rubber- and PVC-lined clamps for chilled-water and mechanical services, isolating noise and thermal movement.'},
      {name:'Plumbing',tag:'Water & drainage',img:'cover-plumbing.jpg',cover:true,desc:'Riser clamps, pipe clamps and U-bolts that carry water and drainage lines on every floor.'},
      {name:'SAM Strut',tag:'Modular framing',img:'cover-sam-strut.jpg',cover:true,desc:'Slotted channel, brackets and fittings for trapeze and cantilever assemblies that adjust on site.'},
      {name:'Steel Structure Support',tag:'Structural fixing',img:'cover-steel-structure.jpg',cover:true,desc:'Load-rated beam clamps that anchor supports to structural steel with no welding or drilling.'},
      {name:'Fixation',tag:'Fastening',img:'cover-fixation.jpg',cover:true,desc:'Threaded rod, drop-in anchors and wall plugs \u2014 the fastening layer of every support run.'},
    ],
    certHead:{kicker:'Certifications', title:'Certified where it counts.'},
    certs:[{name:'UL Listed',code:'UL',img:'ul-listed.jpeg',desc:'Products tested and listed by Underwriters Laboratories for fire-protection service.'},
      {name:'FM Approved',code:'FM',img:'fm-approved.jpeg',desc:'FM Approvals certification for performance and reliability under real-world conditions.'},
      {name:'ISO 9001:2015',code:'ISO',img:'iso-badge.png',desc:'Quality management system certified to ISO 9001:2015 across manufacturing.'}],
    projHead:{kicker:'Featured projects', title:'Trusted on Egypt’s landmark builds.', viewAll:'All projects'},
    pride:{kicker:'Moments of Pride', title:'Achievements worth marking.'},
    prideItems:[{date:'Date',title:'Achievement title',text:'One or two lines on the award, recognition, or landmark delivery.'},
      {date:'Date',title:'Achievement title',text:'One or two lines on the award, recognition, or landmark delivery.'},
      {date:'Date',title:'Achievement title',text:'One or two lines on the award, recognition, or landmark delivery.'}],
    milestones_t:{kicker:'Moments of Pride', title:'A journey of firsts, recognition and trust.',
      sub:'Four landmark moments trace AFROFIX from a local manufacturing idea to internationally certified products, trusted on Egypt\u2019s largest projects.',
      footL:'Built locally \u00b7 Verified globally', footR:'Egypt \u00b7 Middle East \u00b7 Africa'},
    milestones:[
      {year:'1981', tag:'Origin', title:'A local vision begins',
       text:'Eng. Mourad Kelada founds AFROFIX to localise electro-mechanical support systems for the Egyptian market.',
       badge:'Founded in Egypt', img:'journey-01-origin.jpg'},
      {year:'Firsts \u00b7 1990', ysm:true, tag:'Local', title:'Egyptian capability takes shape',
       text:'First in Egypt to introduce universal-plug pipe fixing and to produce strut channel locally \u2014 one of three Egyptian cable-tray makers by 1990.',
       badge:'Egyptian manufacturing firsts', img:'journey-02-local.jpg'},
      {year:'2021\u20132024', tag:'Recognised', title:'Recognised internationally',
       text:'UL Listed clevis and band hangers to UL 203, then FM Approved loop hanger, clevis hanger and riser clamp.',
       badge:'EX28626 \u00b7 PR460156', code:true, certs:['journey-cert-ul.jpg','journey-cert-fm.jpg']},
      {year:'Today', ysm:true, tag:'Trusted', title:'Quality trusted at scale',
       text:'An ISO 9001:2015 certified quality system, a documented record on Egypt\u2019s landmark projects, and supports exported across Africa and the Middle East.',
       badge:'UKS-QMS-25-958', code:true, img:'journey-04-trusted.jpg'}],
    customers_t:{kicker:'Contractors', title:'Chosen by Egypt’s biggest contractors.', sub:'Leading contractors and EPC firms build with AFROFIX supports on their largest programmes.', viewAll:'All contractors'},
    consultants_t:{kicker:'Consultants', title:'Specified by Egypt’s leading consultants.', sub:'AFROFIX supports are named in the specifications of the offices shaping Egypt’s landmark projects.', viewAll:'All consultants'},
    ctaBand:{title:'Specify AFROFIX on your next project.', sub:'Send us your product system and project details — our team replies with a quotation within one business day.', learn:'About AFROFIX'},
  }
};

var PROJECTS = {
  en:[
    {name:'Al-Massa Hotel', place:'New Alamein', cat:'Hospitality', catKey:'Hospitality', img:'massa-hotel.jpg', home:true},
    {name:'Central Bank of Egypt', place:'New Administrative Capital', cat:'Government & Civic', catKey:'Government', img:'central-bank.jpg', detail:true, home:true},
    {name:'Cairo Metro Line 3', place:'Phase 3', cat:'Transportation', catKey:'Transportation', img:'cairo-metro.jpg', home:true},
    {name:'Marassi', place:'North Coast', cat:'Hospitality', catKey:'Hospitality', img:'marassi.jpg', home:true},
    {name:'Opera House', place:'New Administrative Capital', cat:'Government & Civic', catKey:'Government', img:'opera-house.jpg', home:true},
    {name:'Beni Suef Power Plant', place:'Beni Suef', cat:'Industrial', catKey:'Industrial', img:'beni-suef-power.jpg', home:true},
    {name:'Sun City Mall', place:'Cairo', cat:'Commercial', catKey:'Commercial', img:'sun-city-mall.jpg', home:true},
    {name:'Nile City Towers', place:'Cairo', cat:'Commercial', catKey:'Commercial', img:'nile-city.jpg', home:true},
    {name:'Downtown New Alamein', place:'New Alamein', cat:'Commercial', catKey:'Commercial', img:'proj-downtown-alamein.jpg'},
    {name:'Sawary', place:'Alexandria', cat:'Residential', catKey:'Residential', img:'proj-sawary.jpg'},
    {name:'Cairo Monorail', place:'Greater Cairo', cat:'Transportation', catKey:'Transportation', img:'proj-monorail.jpg'},
    {name:'Maspero Towers', place:'Cairo', cat:'Residential', catKey:'Residential', img:'proj-maspero.jpg'},
    {name:'Armed Forces Stadium', place:'New Administrative Capital', cat:'Government & Civic', catKey:'Government', img:'proj-army-stadium.jpg'},
    {name:'Latin District', place:'New Alamein', cat:'Residential', catKey:'Residential', img:'proj-latin-district.jpg'},
    {name:'Olympic City', place:'New Administrative Capital', cat:'Government & Civic', catKey:'Government', img:'proj-olympic-city.jpg'},
    {name:'Warraq Island Development', place:'Giza', cat:'Residential', catKey:'Residential', img:'proj-warraq.jpg'},
    {name:'Magra El-Oyoun Wall', place:'Cairo', cat:'Government & Civic', catKey:'Government', img:'proj-magra-el-oyoun.jpg'},
    {name:'Solar Boats Museum', place:'Giza', cat:'Government & Civic', catKey:'Government', img:'proj-solar-boats.jpg'},
    {name:'The Octagon', place:'New Administrative Capital', cat:'Government & Civic', catKey:'Government', img:'proj-octagon.jpg'},
    {name:'Smart Village', place:'Giza', cat:'Commercial', catKey:'Commercial', img:'proj-smart-village.jpg'},
    {name:'Ain Sokhna Product Hub', place:'Ain Sokhna', cat:'Industrial', catKey:'Industrial', img:'proj-sokhna-hub.jpg'},
    {name:'Assiut Power Plant', place:'Assiut', cat:'Industrial', catKey:'Industrial', img:'proj-assiut-power.jpg'},
    {name:'New Capital Power Plant', place:'New Administrative Capital', cat:'Industrial', catKey:'Industrial', img:'proj-capital-power.jpg'},
    {name:'Egypt High Speed Rail', place:'Nationwide', cat:'Transportation', catKey:'Transportation', img:'proj-high-speed-rail.jpg'},
    {name:'Luxor International Airport', place:'Luxor', cat:'Transportation', catKey:'Transportation', img:'proj-luxor-airport.jpg'},
    {name:'National Liver Institute', place:'Menoufia', cat:'Healthcare', catKey:'Healthcare', img:'proj-liver-institute.jpg'},
    {name:'Research Institute', place:'Egypt', cat:'Education', catKey:'Education', img:'proj-research-institute.jpg'},
    {name:'P&G Plant', place:'Nigeria', cat:'Industrial', catKey:'Industrial', img:'proj-pg-nigeria.jpg'},
  ]
};
// only fill a missing key - the display label and the key now differ
// ("Government & Civic" is shown, 'Government' is the key)
PROJECTS.en.forEach(function(p){ if(!p.catKey) p.catKey = p.cat; });
var CATLABEL = { en:{all:'All Projects',Commercial:'Commercial',Residential:'Residential',Healthcare:'Healthcare',Government:'Government & Civic',Hospitality:'Hospitality',Industrial:'Industrial',Transportation:'Transportation',Education:'Education'} };
var PROJECT_REFS = {"Al-Massa Hotel": ["Ministry of Defense", "ECG", "Orascom Construction", "2018"], "Central Bank of Egypt": ["Egyptian government", "ECG", "Orascom Construction", "2017-2018"], "Cairo Metro Line 3": ["Egyptian government", "Greater Cairo Metro line phase 3 consulting", "Egyptian-French JV", "2022"], "Marassi": ["EMAAR", "", "ATS", "2018"], "Opera House": ["Ministry of Culture", "ECG", "Orascom Construction", "2018"], "Beni Suef Power Plant": ["Egyptian Electricity Holding Co.", "", "El Rowad ME", "2016-2017"], "Sun City Mall": ["HNS Group", "Shaker Consultancy", "HNS Group", "2012"], "Nile City Towers": ["Orascom", "Carillion", "Orascom Construction", "2003"], "Downtown New Alamein": ["New Alamein city authority", "ECG", "CCC-HAC JV", "2020"], "Sawary": ["Saudi Egyptian Developers", "ECG", "JV(REDCON -Rowad -Medcom)", "2024"], "Cairo Monorail": ["NAT", "Hill International", "Alstom-Orascom-Arab Contractors", "2024-2025"], "Maspero Towers": ["New Urban Community Authority", "ACE", "Redcon", "2020"], "Armed Forces Stadium": ["Engineering Authority of Armed Forces", "ACE & Shaker COSMOS", "Orascom Construction", "2020"], "Latin District": ["New Alamein city authority", "ECG", "GAMA", "2021"], "Olympic City": ["Engineering Authority of Armed Forces", "ACE & Shaker COSMOS", "Orascom Construction", "2020"], "Warraq Island Development": ["New Urban Communities Authority", "", "Arab Contractors", "2025"], "Magra El-Oyoun Wall": ["Ministry of Housing, Utilities and Urban Communities", "", "Arab Contractors", "2024"], "Solar Boats Museum": ["Ministry of Tourism and Antiquities", "", "Arab Contractors", "2021"], "The Octagon": ["Egyptian Ministry of Defense / Armed Forces", "Engineering Authority of the Armed Forces", "Orascom Construction, The Arab Contractors, Hassan Allam, and Rowad Modern Engineering", "2024"], "Smart Village": ["Smart Villages Development and Management Company (SVC)", "", "The Arab Contractors and Orascom", "2001"], "Ain Sokhna Product Hub": ["SUMED", "Engineering for the Petroleum & Process Industries (ENPPI)", "Besix-Orascom", "2017"], "Assiut Power Plant": ["Egyptian Electricity Holding Co. (EEHC)", "", "Orascom Construction", "2018-2017"], "New Capital Power Plant": ["Egyptian Electricity Holding Co. (EEHC)", "", "Orascom Construction", "2018-2017"], "Egypt High Speed Rail": ["Ministry of Transport / National Authority for Tunnels (NAT)", "Systra", "The Arab Contractors, Orascom Construction, and Hassan Allam", "2025"], "Luxor International Airport": ["Egyptian Airports Company (Ministry of Civil Aviation)", "Dar Al-Handasah", "The Arab Contractors", "2005"], "National Liver Institute": ["Ministry of Higher Education and Scientific Research", "", "Arab Contractors", "2015-2016"], "P&G Plant": ["Procter & Gamble Egypt", "", "", "2022-2024"]};
var CATLIST = ['Commercial','Residential','Healthcare','Government','Hospitality','Industrial','Transportation','Education'];

var CONTRACTORS = ['Orascom','The Arab Contractors','Consolidated Contractors (CCC)','Hassan Allam Construction','Elsewedy Electric','CSCEC','Concord','GAMA Construction','Redcon'];
var CONSULTANTS = ['DAR','Hill International','Systra','ECG','ACE Moharram Bakhoum','Sabbour','EHAF','SHAKER','Raafat Miller Consulting','Zuhair Fayez Partnership'];

var SOLUTIONS = {
  en:{ allLabel:'All', allTitle:'The full AFROFIX catalogue.', allDesc:'Every certified solution family and sub-product, in one place — filter by discipline above to narrow the view.',
    cats:[
      {name:'Fire Fighting', cover:'cover-fire-fighting.jpg', desc:'UL Listed and FM Approved hangers and clamps for sprinkler and fire-protection piping \u2014 the certified backbone of every fire system.',
        sub:[{name:'Band Hanger (Swivel Ring)',img:'prod-band-hanger-ul-fm.jpg',bg:'#f7f7f7'},{name:'Clevis Hanger',img:'prod-clevis-hanger-ul-fm.jpg',bg:'#f7f7f7'},{name:'Riser Clamp',img:'prod-riser-clamp-fm.jpg',bg:'#f3f3f3'},{name:'Riser Clamp with PVC',img:'prod-riser-clamp-pvc-fm.png'},{name:'U-Bolt',img:'prod-u-bolt.png'},{name:'U-Bolt with PVC Hose',img:'prod-u-bolt-pvc-hose.png'}]},
      {name:'HVAC', cover:'cover-hvac.jpg', desc:'Channel, fixings and insulated cradles for chilled-water and mechanical services, isolating thermal movement and noise on insulated lines.',
        sub:[{name:'SAM Strut Channel',img:'prod-sam-strut-channel.jpg',bg:'#ffffff'},{name:'U-Bolt',img:'prod-u-bolt.png'},{name:'Insulation Wood Frame',img:'prod-wooden-support.jpg',bg:'#e9e9e9'}]},
      {name:'Plumbing', cover:'cover-plumbing.jpg', desc:'Pipe clamps, offset clamps and U-bolts that carry potable water and drainage lines reliably on every floor.',
        sub:[{name:'DSM Pipe Clamp',img:'prod-dsm-pipe-clamp.jpg',bg:'#f7f7f7'},{name:'Fixation Set',img:'prod-fixation-set.jpg',bg:'#f0f0f0'},{name:'Offset Pipe Clamp',img:'prod-offset-pipe-clamp.jpg',bg:'#f2f2f2'},{name:'U-Bolt',img:'prod-u-bolt.png'}]},
      {name:'SAM Strut', cover:'cover-sam-strut.jpg', desc:'Slotted channel, brackets and clamps for trapeze and cantilever assemblies that adjust and expand on site \u2014 no welding, no drilling.',
        sub:[{name:'Bracket',img:'prod-bracket.jpg',fit:'cover'},{name:'Beam Clamp for SAM Strut Channel',img:'prod-beam-clamp-for-sam-strut-channel.jpg',bg:'#ccd4e7'},{name:'Pipe Clamp on SAM Channel',img:'prod-pipe-clamp-on-sam-channel.jpg',fit:'cover'},{name:'SAM Strut Channel',img:'prod-sam-strut-channel.jpg',bg:'#ffffff'}]},
      {name:'Steel Structure Support', cover:'cover-steel-structure.jpg', desc:'Load-rated beam clamps that anchor supports to structural steel with no welding or drilling \u2014 fast, reversible and rated.',
        sub:[{name:'Beam Clamp Type A',img:'prod-beam-clamp-type-a.jpg',bg:'#f0f0f0'},{name:'Beam Clamp Type B',img:'prod-beam-clamp-type-b.jpg',bg:'#e1e1e1'},{name:'Beam Clamp for SAM Strut Channel',img:'prod-beam-clamp-for-sam-strut-channel.jpg',bg:'#ccd4e7'},{name:'Beam Clamp for Pipe',img:'prod-beam-clamp-for-pipe.jpg',bg:'#dfdfdf'}]},
      {name:'Fixation', cover:'cover-fixation.jpg', desc:'Threaded rod, drop-in anchors and wall-plug sets \u2014 the fastening layer that ties every support run to the structure.',
        sub:[{name:'Double-Thread Screw with Wall Plug',img:'prod-fixation-set.jpg',bg:'#f0f0f0'},{name:'Drop-In Anchor',img:'prod-drop-in-anchor.jpg',bg:'#c8c8c8'},{name:'Threaded Rod',img:'prod-threaded-rod.jpg',bg:'#f0f0f0'}]},
    ],
    ctaBand:{title:'Need load ratings or a bill of materials?', sub:'Send us the discipline and project — we’ll quote the exact parts and ratings you need.'} }
};

var CERTPAGE = {
  en:{ head:{kicker:'Certifications', title:'Certified where it counts.', sub:'AFROFIX is one of the pioneer Egyptian manufacturers of products certified by Underwriters Laboratories and FM Approvals, produced under a certified quality management system.'},
    certs:[{name:'UL Listed',img:'ul-listed.jpeg',desc:'Products tested and listed by Underwriters Laboratories, verifying they meet nationally recognised safety standards for fire-protection service.'},
      {name:'FM Approved',img:'fm-approved.jpeg',desc:'FM Approvals certification confirming performance, reliability and quality under demanding real-world conditions.'},
      {name:'ISO 9001:2015',img:'iso-badge.png',code:'ISO',desc:'A quality management system certified to ISO 9001:2015, governing manufacturing, traceability and continuous improvement.'}],
    quality:{kicker:'Quality', title:'Rated, traceable, repeatable.', body:'Every product line is manufactured in-house so material, load rating and finish stay consistent from batch to batch — and can be documented for consultants and authorities on request.',
      points:['Load-rated to published working loads','Material and finish traceability','In-house testing and QC','Documentation available for submittals']},
    docsHead:{kicker:'Documents', title:'The certificates themselves.', sub:'The issued certificates for AFROFIX products and quality management.'},
    docs:[{name:'UL Certificate of Compliance', img:'cert-ul.jpg'},
      {name:'FM Certificate of Compliance', img:'cert-fm.jpg'},
      {name:'ISO 9001:2015 Certificate of Registration', img:'cert-iso.jpg'}] }
};

var ABOUT = {
  en:{ kicker:'Who we are', title:'Egypt\u2019s first electro-mechanical support manufacturer.',
    p1:'The African Company for Trading & Engineering (AFROFIX) is the first manufacturer in Egypt specialised in producing electro-mechanical support systems and parts for industrial, commercial and utility installations. We produce complete pipe support systems, beam clamps, brackets, complete mechanical cladding fixation systems, concrete inserts and steel framing systems.',
    p2:'Our products have been used by many of the Egyptian main contractors \u2014 including Orascom Construction, The Arab Contractors, Hassan Allam, REDCON, NAFFCO, CCC and Contrack \u2014 on projects across Egypt, the Middle East and Africa. AFROFIX is approved by many prestigious engineering consultancies, among them Dar Al-Handasah, Dr. Shaker Consultancy Group, ECG, Sabbour and RMC.',
    profile:'Download company profile', seeWork:'See our work',
    stats:[{num:'40+',label:'Years manufacturing'},{num:'6',label:'Solution categories'},{num:'UL \u00b7 FM',label:'Certified products'},{num:'60+',label:'Landmark projects'}],
    mvKicker:'Mission & vision', mvTitle:'What we set out to do.',
    missionHead:'Our mission',
    mission:['AFROFIX seeks to provide products and services with the highest standards of quality. So we permanently develop our product range to comply with international standards like the Manufacturers Standardization Society (MSS), Deutsches Institut f\u00fcr Normung (DIN) and others, to meet our customers\u2019 expectations for durable and standardised products.',
      'As an expert in the electro-mechanical support field for more than 30 years, we don\u2019t only supply \u2014 we consult with the main engineering houses regarding suitable materials and technical design choices that will meet their needs.'],
    visionHead:'Our vision', visionLead:'As an Egyptian company, our vision is:',
    vision:['To positively affect the Egyptian economy by offering to the local market products that were once imported.',
      'Seeking exporting opportunities to the Middle East, African and European markets.',
      'Working on our employees\u2019 development to help them shape the future direction of their careers.'],
    chairKicker:'Leadership', chairName:'Eng. Mourad Kelada', chairRole:'Chairman',
    chair:['Eng. Mourad Kelada, Chairman of The African Company for Trading & Engineering (AFROFIX), received his bachelor\u2019s degree in Civil Engineering from Ain Shams University in 1962. He worked in many multinational organisations until 1981, when he founded AFROFIX.',
      'As a pioneer, he identified the Egyptian market\u2019s need for electro-mechanical support systems, and started his business in that unique, propitious niche.',
      'He was the first in Egypt to introduce the idea of using universal plastic plugs to mount pipe clamps to walls, and also the first to produce the strut channels used in steel framing systems in the Egyptian market. In 1990, due to his efforts, AFROFIX became one of the biggest three companies in Egypt producing cable trays.'],
    ctaTitle:'See who builds and specifies with AFROFIX.', ctaSub:'Browse the contractors executing our largest programmes and the consultants who specify our supports.', ctaContractors:'View contractors', ctaConsultants:'View consultants' }
};

var CONTRACTORS_PAGE = {
  en:{ kicker:'Contractors', title:'Chosen by Egypt’s biggest contractors.', sub:'Leading contractors and EPC firms build with AFROFIX supports on their largest programmes — from power plants and metro lines to hotels, towers and shopping destinations.',
    ctaBand:{title:'Specify AFROFIX on your next contract.', sub:'Send us your product system and project details — our team replies with a quotation within one business day.'} }
};
var CONSULTANTS_PAGE = {
  en:{ kicker:'Consultants', title:'Specified by Egypt’s leading consultants.', sub:'AFROFIX supports are named in the specifications of the design and engineering offices shaping Egypt’s landmark projects.',
    ctaBand:{title:'Specifying AFROFIX on a project?', sub:'Send us the discipline and project — our engineering team will support the specification from day one.'} }
};

var CENTRALBANK = {
  en:{ back:'All projects', kicker:'Institutional · New Administrative Capital', title:'Central Bank of Egypt',
    p1:'The Central Bank of Egypt’s new headquarters in the New Administrative Capital is one of the country’s largest institutional developments, built to house the nation’s monetary authority behind a monumental limestone-clad facade.',
    p2:'AFROFIX supplied load-rated pipe hangers, clamps and strut-channel supports across the building’s fire-protection, HVAC and plumbing systems — engineered and UL Listed / FM Approved to the same standard used across the company’s landmark project work.',
    note:'Client, consultant and delivery year to be confirmed with the project team before publishing.', scopeLabel:'Scope supplied',
    meta:[{label:'Location',value:'New Administrative Capital, Egypt'},{label:'Category',value:'Institutional'},{label:'Client',value:'[To be confirmed]'},{label:'Consultant',value:'[To be confirmed]'},{label:'Year',value:'[To be confirmed]'}],
    scope:['Fire fighting supports','HVAC trapeze assemblies','Plumbing risers'],
    ctaBand:{title:'Building something at this scale?', sub:'Tell us about your project — our engineering team will support the specification from day one.'} }
};

var CONTACT = {
  en:{ kicker:'Contact', title:'Request a quotation.', sub:'Tell us the product system and your project, and our team will get back to you with a quotation.',
    addressLabel:'Address', phoneLabel:'Call us', emailLabel:'Email', formTitle:'Ask for a quotation', formSub:'We reply within one business day.', readyList:['Your project name and location','The product system and sizes you need','Quantities and required finish','Any drawings or submittals to attach'], formNote:'Opens the AFROFIX quotation form — our team replies within one business day.',
    fName:'Full name', fCompany:'Company', fEmail:'Email', fProduct:'Product system', fMessage:'Project details',
    fFiles:'Drawings / BOQ (optional)', fFilesHint:'Drop files or click to upload', fFilesTypes:'PDF, DWG or XLSX',
    thanksTitle:'Thank you.', thanksBody:'Your request has been received. Our team will reach out with a quotation shortly.',
    productNames:['Fire Fighting','HVAC','Plumbing','SAM Strut','Steel Structure Support','Fixation'] }
};

var SEARCH_INDEX_BASE = [
  {en:'Home',cat:'Page',href:'#/'},
  {en:'Solutions',cat:'Page',href:'#/solutions'},
  {en:'Projects',cat:'Page',href:'#/projects'},
  {en:'Certificates',cat:'Page',href:'#/certificates'},
  {en:'About',cat:'Page',href:'#/about'},
  {en:'Contractors',cat:'Page',href:'#/contractors'},
  {en:'Consultants',cat:'Page',href:'#/consultants'},
  {en:'Contact us',cat:'Page',href:'#/contact'},
  {en:'Fire Fighting',cat:'Solution',href:'#/solutions'},
  {en:'HVAC',cat:'Solution',href:'#/solutions'},
  {en:'Plumbing',cat:'Solution',href:'#/solutions'},
  {en:'SAM Strut',cat:'Solution',href:'#/solutions'},
  {en:'Steel Structure Support',cat:'Solution',href:'#/solutions'},
  {en:'Fixation',cat:'Solution',href:'#/solutions'},
  {en:'Clevis Hanger',cat:'Product',href:'#/solutions'},
  {en:'Riser Clamp',cat:'Product',href:'#/solutions'},
  {en:'Beam Clamp',cat:'Product',href:'#/solutions'},
  {en:'U-Bolt',cat:'Product',href:'#/solutions'},
  {en:'Threaded Rod',cat:'Product',href:'#/solutions'},
  {en:'Slotted Channel',cat:'Product',href:'#/solutions'},
  {en:'UL Listed',cat:'Certificate',href:'#/certificates'},
  {en:'FM Approved',cat:'Certificate',href:'#/certificates'},
  {en:'ISO 9001:2015',cat:'Certificate',href:'#/certificates'},
  {en:'Central Bank of Egypt',cat:'Project',href:'#/projects/central-bank'},
  {en:'Cairo Metro Line 3',cat:'Project',href:'#/projects'},
  {en:'Al-Massa Hotel',cat:'Project',href:'#/projects'},
  {en:'Marassi',cat:'Project',href:'#/projects'},
];

/* ---------- state ---------- */
var state = { lang:'en', product:'', solCat:'all', projCat:'all', homeProjCat:'all', solIdx:0, submitted:false, q:'', menuOpen:false };

function firmCell(name){
  var file = LOGO[name];
  if (file) return '<img class="firm-logo" dir="ltr" src="'+I(file)+'" alt="'+esc(name)+'" title="'+esc(name)+'" loading="lazy">';
  return '<span class="firm-name">'+esc(name)+'</span>';
}
function t(){ return state.lang==='ar' ? 'ar' : 'en'; }
function isAr(){ return state.lang==='ar'; }

// Quotation requests go to the AFROFIX ERPNext web form so they land in the ERP.
var QUOTE_URL = 'https://production-afrofix.frappe.cloud/contact-us/new';
var QUOTE_ATTRS = ' href="'+QUOTE_URL+'" target="_blank" rel="noopener noreferrer"';

/* What each nav item drops down. Solutions lists the real products of the
   category you are pointing at; the others preview with a photo or, for
   Contact, the actual channels. */
function megaAbout(){
  var ar = isAr();
  return [
    {label: ar?'\u0645\u0644\u0641 \u0627\u0644\u0634\u0631\u0643\u0629':'Company profile',   href:'#/about',            img:'mourad.jpg', fit:'contain'},
    {label: ar?'\u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0648\u0627\u0644\u0631\u0624\u064a\u0629':'Mission & vision', href:'#/about/mission',    img:'journey-04-trusted.jpg'},
    {label: ar?'\u0627\u0644\u0642\u064a\u0627\u062f\u0629':'Leadership',                       href:'#/about/leadership', img:'journey-01-origin.jpg', fit:'contain'},
    {label: ar?'\u0627\u0644\u0634\u0647\u0627\u062f\u0627\u062a':'Certificates',              href:'#/certificates',     img:'cert-ul.jpg', fit:'contain'},
    {label: ar?'\u0627\u0644\u0645\u0642\u0627\u0648\u0644\u0648\u0646':'Main contractors',   href:'#/contractors',      img:'nile-city.jpg'},
    {label: ar?'\u0627\u0644\u0627\u0633\u062a\u0634\u0627\u0631\u064a\u0648\u0646':'Consultants', href:'#/consultants',  img:'central-bank.jpg'}
  ];
}

function megaItems(kind){
  if(kind === 'products'){
    return SOLUTIONS[t()].cats.map(function(c, i){
      return { label:c.name, img:c.cover, href:'#/solutions/'+i, sub:c.sub||[], idx:i };
    });
  }
  if(kind === 'about') return megaAbout();
  if(kind === 'contact'){
    var ar = isAr();
    return [
      {label: ar?'\u0646\u0645\u0648\u0630\u062c \u0627\u0644\u062a\u0648\u0627\u0635\u0644':'Contact page', href:'#/contact'},
      {label: ar?'\u0637\u0644\u0628 \u0639\u0631\u0636 \u0633\u0639\u0631':'Request a quotation', href:QUOTE_URL},
      {label: ar?'\u0645\u0648\u0642\u0639 \u0627\u0644\u0645\u0635\u0646\u0639':'Find the factory',
       href:'https://maps.google.com/?q=Plot+No.+132+6th+Industrial+Zone+Extension+6th+October+City+Egypt'}
    ];
  }
  var projs = PROJECTS[t()], labels = CATLABEL[t()];
  return CATLIST.filter(function(k){
    return projs.some(function(p){ return (p.catKey||p.cat) === k; });
  }).map(function(k){
    var hit = null;
    for(var i=0;i<projs.length;i++){
      if((projs[i].catKey||projs[i].cat) === k){ hit = projs[i]; break; }
    }
    return { label:labels[k], href:'#/projects/'+k, img:hit ? hit.img : '' };
  });
}

var MEGA_ARROW = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"'
  + ' stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
  + '<path d="M5 12h13"/><path d="M12 5l7 7-7 7"/></svg>';

/* one product tile inside the Solutions panel */
function megaProd(sub){
  var photo = sub.fit === 'cover';
  var tile  = photo ? 'var(--color-accent-900)'
                    : (sub.bg || 'radial-gradient(circle at 50% 40%,#eef1f5,#c9d0d8)');
  var fit   = photo ? 'cover' : 'contain';
  return '<a class="af-mega__prod" href="'+productHref(sub.img)+'">'
    + '<span class="af-mega__thumb" style="background:'+tile+'">'
    + '<img src="'+I(sub.img)+'" alt="" loading="lazy" decoding="async" style="object-fit:'+fit+'">'
    + '</span><span class="af-mega__nm">'+esc(sub.name)+'</span></a>';
}

function megaPanel(kind){
  var items = megaItems(kind);
  if(!items.length) return '';
  var ar = isAr();

  var list = items.map(function(it, i){
    return '<a class="af-mega__item'+(i===0?' is-on':'')+'" href="'+it.href+'"'
      + ' data-img="'+esc(it.img)+'"'
      + (it.pos ? ' data-pos="'+esc(it.pos)+'"' : '')
      + (it.fit ? ' data-fit="'+esc(it.fit)+'"' : '')
      + ' data-mega-item data-label="'+esc(it.label)+'">'
      + '<span>'+esc(it.label)+'</span>'+MEGA_ARROW+'</a>';
  }).join('');

  var right;
  if(kind === 'contact'){
    var B = BASE[t()];
    right = '<div class="af-mega__card">'
      + '<div class="af-mega__row"><span class="af-mega__lab">'+esc(ar?'\u0627\u0644\u0639\u0646\u0648\u0627\u0646':'Factory')+'</span>'
      + '<span class="af-mega__val">'+esc(B.footer.addr)+'</span></div>'
      + '<div class="af-mega__row"><span class="af-mega__lab">'+esc(ar?'\u0627\u0644\u0647\u0627\u062a\u0641':'Phone')+'</span>'
      + '<a class="af-mega__val" dir="ltr" href="tel:+201001012905">(+2) 0100 1012 905</a>'
      + '<a class="af-mega__val" dir="ltr" href="tel:+201272522278">(+2) 0127 2522 278</a></div>'
      + '<div class="af-mega__row"><span class="af-mega__lab">'+esc(ar?'\u0627\u0644\u0628\u0631\u064a\u062f':'Email')+'</span>'
      + '<a class="af-mega__val" dir="ltr" href="mailto:info@afrofix.com">info@afrofix.com</a>'
      + '<a class="af-mega__val" dir="ltr" href="mailto:sales@afrofix.com">sales@afrofix.com</a></div>'
      + '</div>';
  } else {
    right = '<figure class="af-mega__preview">'
      + '<img src="'+I(items[0].img)+'" alt="" loading="lazy" decoding="async"'
      + ' style="object-fit:'+(items[0].fit||'cover')
      + ';object-position:'+(items[0].pos||'50% 50%')+'">'
      + '<figcaption>'+esc(items[0].label)+'</figcaption></figure>';
  }

  var wide = kind === 'contact' ? ' af-mega--contact' : '';
  return '<div class="af-mega'+wide+'"><div class="af-mega__inner">'
    + '<div class="af-mega__list">'+list+'</div>'+right+'</div></div>';
}

function renderHeader(activeKey){
  var b = BASE[t()];
  var navPages = [['home','/'],['about','/pages/about'],['products','/collections'],['projects','/pages/projects'],['contact','/pages/contact']];
  var HAS_MEGA = { products:1, projects:1, about:1, contact:1 };
  var links = navPages.map(function(p){
    var key=p[0], href=p[1];
    var cls = key===activeKey ? 'af-navlink active' : 'af-navlink';
    var a = '<a class="'+cls+'" href="'+href+'"'
          + (HAS_MEGA[key] ? ' aria-haspopup="true"' : '')+'>'+esc(b.nav[key])+'</a>';
    return HAS_MEGA[key] ? '<div class="af-navgroup">'+a+megaPanel(key)+'</div>' : a;
  }).join('');

  var allPages = [['home','/'],['products','/collections'],['projects','/pages/projects'],['certs','/pages/certificates'],['about','/pages/about'],['contractors','#/contractors'],['consultants','#/consultants'],['contact','/pages/contact']];
  var dropLinks = allPages.map(function(p){
    var key=p[0], href=p[1];
    var cls = key===activeKey ? 'active' : '';
    return '<a class="'+cls+'" href="'+href+'">'+esc(b.nav[key])+'</a>';
  }).join('');
  var searchResultsHtml = '';
  if(state.q.trim()){
    var q=state.q.trim().toLowerCase();
    var results = SEARCH_INDEX_BASE.filter(function(r){ return (r.en).toLowerCase().indexOf(q)>=0; }).slice(0,6);
    if(results.length){
      searchResultsHtml = '<div class="searchdrop">'+results.map(function(r){
        return '<a href="'+r.href+'"><span>'+esc(r.en)+'</span><span class="cat">'+esc(r.cat)+'</span></a>';
      }).join('')+'</div>';
    }
  }
  var menuHtml = state.menuOpen ? '<div class="navdrop">'
    +'<div class="field" style="margin-bottom:10px;position:relative"><input id="searchInputMobile" class="input" placeholder="'+('Search')+'" value="'+esc(state.q)+'">'+searchResultsHtml+'</div>'
    +dropLinks+'</div>' : '';
  return ''
    +'<header class="site"><nav>'
    +'<a href="#/" dir="ltr" style="display:flex;align-items:center;text-decoration:none;flex:none"><img src="'+I('afrofix-logo-tagline-light.png')+'" alt="AFROFIX — The African Co. for Trading & Engineering" style="height:38px;width:auto;display:block"></a>'
    +'<div class="navlinks" style="margin-inline-end:auto">'+links+'</div>'
    +'<button class="navtoggle" data-action="menu-toggle" aria-label="Menu">'
    +'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>'
    +'</button>'
    +'<div class="searchwrap"><input id="searchInput" class="input" placeholder="'+('Search')+'" value="'+esc(state.q)+'">'+searchResultsHtml+'</div>'
    +'<a class="btn btn-primary hdr-cta"'+QUOTE_ATTRS+' style="white-space:nowrap"><span class="cta-long">'+esc(b.cta.quote)+'</span><span class="cta-short">'+esc(b.cta.quoteShort)+'</span></a>'
    +menuHtml
    +'</nav></header>';
}

var SOCIALS = [
  {name:'LinkedIn', href:'https://www.linkedin.com/company/the-african-company-for-trading-and-engineering-afrofix/',
   svg:'<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9h4v12H3V9Zm7 0h3.8v1.7h.05c.53-1 1.83-2.05 3.77-2.05C21.6 8.65 23 10.6 23 14v7h-4v-6.2c0-1.5-.03-3.4-2.08-3.4-2.08 0-2.4 1.62-2.4 3.3V21h-4V9Z"/></svg>'},
  {name:'Facebook', href:'https://www.facebook.com/profile.php?id=61560044226695',
   svg:'<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.15 8.44 9.94v-7.03H7.9v-2.9h2.54V9.85c0-2.52 1.5-3.91 3.77-3.91 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.78-1.63 1.57v1.89h2.78l-.45 2.9h-2.33V22c4.78-.79 8.44-4.93 8.44-9.94Z"/></svg>'},
  {name:'Instagram', href:'https://www.instagram.com/afro_fix/',
   svg:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" stroke="none"/></svg>'}
];
function socialsHtml(){
  return '<div class="foot-social">'+SOCIALS.map(function(o){
    return '<a href="'+o.href+'" target="_blank" rel="noopener noreferrer" aria-label="'+esc(o.name)+'" title="'+esc(o.name)+'">'+o.svg+'</a>';
  }).join('')+'</div>';
}

function renderFooter(){
  var b = BASE[t()];
  var footPages = [['home','/'],['products','/collections'],['projects','/pages/projects'],['certs','/pages/certificates'],['about','/pages/about'],['contractors','#/contractors'],['consultants','#/consultants'],['contact','/pages/contact']];
  var links = footPages.map(function(p){ return '<a class="af-link" href="'+p[1]+'">'+esc(b.nav[p[0]])+'</a>'; }).join('');
  return ''
   +'<footer class="site">'
   +'<div class="foot-grid">'
   +'<div><div dir="ltr" style="display:flex;align-items:center"><img src="'+I('afrofix-logo-tagline-light.png')+'" alt="AFROFIX — The African Co. for Trading & Engineering" style="height:48px;width:auto;display:block"></div>'
   +'<p style="font-size:14px;line-height:1.6;color:var(--color-neutral-400);margin:16px 0 20px;max-width:36ch">'+esc(b.footer.tag)+'</p>'
   +'<div style="display:flex;gap:8px;flex-wrap:wrap"><span class="tag tag-outline">UL Listed</span><span class="tag tag-outline">FM Approved</span><span class="tag tag-outline">ISO 9001:2015</span></div>'
   + socialsHtml()+'</div>'
   +'<div><div class="foot-head">'+esc(b.footer.exploreHead)+'</div><div style="display:flex;flex-direction:column;gap:12px">'+links+'</div></div>'
   +(t()==='en' ? '<div><div class="foot-head">Resources</div><div style="display:flex;flex-direction:column;gap:12px">'+'<a class="af-link" href="/pages/faq">FAQ</a>'+'<a class="af-link" href="/pages/technical-submittals">Technical submittals</a>'+'<a class="af-link" href="/pages/custom-manufacturing">Custom manufacturing</a>'+'<a class="af-link" href="/pages/project-support">Specification &amp; project support</a>'+'<a class="af-link" href="/blogs/news">News &amp; articles</a>'+'</div></div>' : '')
   +'<div><div class="foot-head">'+esc(b.footer.contactHead)+'</div><div style="display:flex;flex-direction:column;gap:14px">'
   +'<a class="af-link af-map" href="'+MAPS_URL+'" target="_blank" rel="noopener" style="display:flex;gap:8px;align-items:flex-start;font-size:14px;line-height:1.55;max-width:34ch">'
   +'<span style="margin-top:2px;color:var(--color-accent)">'+PIN_SVG+'</span><span>'+esc(b.footer.addr)+'</span></a>'
   +'<a class="af-link" dir="ltr" href="tel:+201001012905" style="align-self:flex-start">(+2) 0100 1012 905</a>'
   +'<a class="af-link" dir="ltr" href="tel:+201272522278" style="align-self:flex-start">(+2) 0127 2522 278</a>'
   +'<a class="af-link" href="mailto:info@afrofix.com" style="align-self:flex-start">info@afrofix.com</a>'
   +'<a class="af-link" href="mailto:sales@afrofix.com" style="align-self:flex-start">sales@afrofix.com</a>'
   +'</div></div></div>'
   +'<div class="foot-bottom"><div style="font-size:12px;color:var(--color-neutral-400)">© 2026 '+esc(b.footer.company)+'</div>'
   +'<a class="btn btn-secondary"'+QUOTE_ATTRS+' style="padding:8px 18px;font-size:13px">'+esc(b.cta.quote)+'</a></div>'
   +'</footer>';
}

function renderHome(){
  var c = HOME[t()]; var b = BASE[t()];
  var solCats = (SOLUTIONS[t()] && SOLUTIONS[t()].cats) || [];
  var viewAllTxt = 'View all';
  var productsHtml = c.products.map(function(p,i){
    var subs = (solCats[i] && solCats[i].sub) || [];
    /* The products live in a sibling of the card's link, not inside it - an
       anchor cannot contain other anchors. */
    var pop = subs.length ? '<div class="af-solcard__pop">'
      + '<div class="af-solcard__hd">'+esc(p.name)+'</div>'
      + '<div class="af-solcard__grid">'+subs.slice(0,6).map(megaProd).join('')+'</div>'
      + '<a class="af-mega__all" href="#/solutions/'+i+'">'
      + esc(viewAllTxt+' \u00b7 '+subs.length)+MEGA_ARROW+'</a></div>' : '';
    return '<div class="af-solcard reveal" style="transition-delay:'+(i*70)+'ms">'
      +'<a class="card af-prod elev-sm" style="padding:0;overflow:hidden;border-radius:var(--radius-lg)" href="#/solutions/'+i+'">'
      +'<div style="position:relative;aspect-ratio:16/10;overflow:hidden;background:'+(p.cover?'var(--color-accent-900)':'radial-gradient(circle at 50% 32%,#eef1f5,#c9d0d8)')+'">'
      +(p.cover
         ? '<img src="'+I(p.img)+'" alt="'+esc(p.name)+'" loading="lazy" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover">'
         : '<img src="'+I(p.img)+'" alt="'+esc(p.name)+'" loading="lazy" style="position:absolute;inset:16px;width:calc(100% - 32px);height:calc(100% - 32px);object-fit:contain">')
      +'</div><div style="padding:20px 20px 22px;display:flex;flex-direction:column;gap:8px">'
      +'<div style="font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:var(--color-accent)">'+esc(p.tag)+'</div>'
      +'<h3 style="font-size:19px;line-height:1.2;margin:0">'+esc(p.name)+'</h3>'
      +'<p style="font-size:13.5px;line-height:1.55;color:var(--color-neutral-300);margin:0">'+esc(p.desc)+'</p></div></a>'
      + pop + '</div>';
  }).join('');

  var certsHtml = c.certs.map(function(cert){
    var chip = cert.img
      ? '<img src="'+I(cert.img)+'" alt="'+esc(cert.name)+'" style="width:100%;height:100%;object-fit:contain">'
      : '<span style="font-family:var(--font-heading);font-weight:700;color:var(--color-neutral-400);font-size:15px">'+esc(cert.code)+'</span>';
    var bg = cert.img ? '#ffffff' : 'var(--color-bg)';
    return '<div class="card elev-sm" style="padding:26px;flex-direction:row;gap:20px;align-items:flex-start;border-radius:var(--radius-lg)">'
      +'<div style="width:74px;height:74px;flex:none;border-radius:var(--radius-md);border:1px solid var(--color-divider);display:grid;place-items:center;padding:10px;background:'+bg+'">'+chip+'</div>'
      +'<div><h3 style="font-size:18px;margin:0 0 6px">'+esc(cert.name)+'</h3><p style="font-size:13px;line-height:1.55;color:var(--color-neutral-300);margin:0">'+esc(cert.desc)+'</p></div></div>';
  }).join('');

  var allProjs = PROJECTS[t()].filter(function(p){ return p.home; });
  var homeLabels = CATLABEL[t()];
  var homeSel = state.homeProjCat;
  var homeCatsPresent = CATLIST.filter(function(k){ return allProjs.some(function(p){ return (p.catKey||p.cat)===k; }); });
  var homeTabsHtml = '<button type="button" class="af-tab '+(homeSel==='all'?'af-tab-active':'')+'" data-action="home-proj-tab" data-cat="all">'+esc(homeLabels.all)+'</button>'
    + homeCatsPresent.map(function(k){ return '<button type="button" class="af-tab '+(homeSel===k?'af-tab-active':'')+'" data-action="home-proj-tab" data-cat="'+k+'">'+esc(homeLabels[k])+'</button>'; }).join('');
  var projs = homeSel==='all' ? allProjs : allProjs.filter(function(p){ return (p.catKey||p.cat)===homeSel; });
  var projHtml = projs.map(function(p){
    var href = p.detail ? '#/projects/central-bank' : '#/projects';
    return '<a class="af-proj" href="'+href+'" style="aspect-ratio:1/1;border-radius:var(--radius-md)">'
      +'<div class="af-proj-img" style="background-image:url('+I(p.img)+')"></div>'
      +'<div style="position:absolute;inset:0;background:linear-gradient(to top,color-mix(in srgb,var(--color-bg) 92%,transparent) 6%,transparent 56%);pointer-events:none"></div>'
      +'<div style="position:absolute;inset-inline:0;bottom:0;padding:16px;pointer-events:none">'
      +'<span style="display:inline-block;font-size:10px;letter-spacing:.08em;text-transform:uppercase;padding:3px 8px;border-radius:6px;background:color-mix(in srgb,var(--color-accent) 22%,transparent);color:var(--color-accent-200);margin-bottom:8px">'+esc(p.cat)+'</span>'
      +'<div style="font-size:14px;font-weight:600;line-height:1.25;color:var(--color-text)">'+esc(p.name)+'</div>'
      +'<div style="font-size:11px;color:var(--color-neutral-300);margin-top:3px">'+esc(p.place)+'</div></div></a>';
  }).join('');

  var mopHtml = c.milestones.slice(0,4).map(function(m,i){
    var media = m.certs
      ? '<div class="mop-certs">'+m.certs.map(function(f){ return '<img src="'+I(f)+'" alt="" loading="lazy">'; }).join('')+'</div>'
      : '<div class="mop-media" style="background-image:url('+I(m.img)+')"></div>';
    return '<article class="mop-m '+(i%2===0?'mop-m--up':'mop-m--dn')+'" role="listitem" style="--x:'+MOP_X[i]+';transition-delay:'+(i*90)+'ms">'
      +'<div class="mop-node">'
      +'<span class="mop-idx" aria-hidden="true">0'+(i+1)+'</span>'
      +'<div class="mop-ring">'+media+'</div>'
      +'<span class="mop-tag">'+esc(m.tag)+'</span></div>'
      +'<div class="mop-card">'
      +'<span class="mop-year'+(m.ysm?' mop-year--sm':'')+'">'+esc(m.year)+'</span>'
      +'<h3 class="mop-ch">'+esc(m.title)+'</h3>'
      +'<p class="mop-cb">'+esc(m.text)+'</p>'
      +'<span class="mop-badge'+(m.code?' mop-badge--code':'')+'">'+esc(m.badge)+'</span>'
      +'</div></article>';
  }).join('');

  var contractorsHtml = CONTRACTORS.slice(0,8).map(firmCell).join('');
  var consultantsHtml = CONSULTANTS.slice(0,8).map(firmCell).join('');

  return ''
   +'<div class="page-bg home-bg">'
   + renderHeader('home')
   +'<section class="hero-slider" data-hero aria-roledescription="carousel" aria-label="'+('Product showcase')+'">'
   +'<h1 class="sr-only">AFROFIX — UL Listed &amp; FM Approved pipe support systems manufacturer in Egypt</h1>'
   +'<div class="hero-track">'
   + HERO_SLIDES.map(function(s,i){
       return '<div class="hero-slide'+(i===0?' on':'')+'" data-hero-slide aria-hidden="'+(i===0?'false':'true')+'">'
         +'<picture><source media="(max-width:760px)" srcset="'+I(s.img.replace('.webp','-sm.webp'))+'">'
         +'<img src="'+I(s.img)+'" alt="'+esc(s.en)+'" width="1672" height="940" decoding="async"'+(i===0?' fetchpriority="high"':' loading="lazy"')+'></picture>'
         +'<div class="hx"><div class="hx-in">'
         +'<p class="hx-k">'+esc(s.kicker)+'</p>'
         +'<h2 class="hx-h">'+esc(s.h[0])+'<br><span'+(s.acc?' class="hx-acc"':'')+'>'+esc(s.h[1])+'</span></h2>'
         +'<p class="hx-sub">'+esc(s.sub)+'</p>'
         +'<p class="hx-spec">'+esc(s.spec)+'</p>'
         +'<div class="hx-cta"><a class="hx-btn hx-p" href="'+s.href+'">'+esc(s.pl)+HERO_ARROW+'</a>'
         +'<a class="hx-btn hx-s"'+QUOTE_ATTRS+'>'+esc(s.sl)+'</a></div>'
         +'</div></div></div>';
     }).join('')
   +'</div>'
   +'<div class="hero-ui">'
   +'<button type="button" class="hero-arrow" data-hero-nav="-1" aria-label="'+('Previous slide')+'">'+CHEV.prev+'</button>'
   +'<div class="hero-dots">'
   + HERO_SLIDES.map(function(s,i){
       return '<button type="button" class="hero-dot'+(i===0?' on':'')+'" data-hero-dot="'+i+'" aria-label="'+('Slide ')+(i+1)+'"></button>';
     }).join('')
   +'</div>'
   +'<button type="button" class="hero-arrow" data-hero-nav="1" aria-label="'+('Next slide')+'">'+CHEV.next+'</button>'
   +'</div></section>'

   +'<section class="wrap reveal" style="padding-block:56px"><div class="card elev-md" style="border-radius:var(--radius-lg);padding:52px 44px;background:radial-gradient(760px 320px at 50% -20%,color-mix(in srgb,var(--color-accent) 16%,transparent),transparent 70%),var(--color-surface)">'
   +'<div class="grid-4" style="text-align:center">'+c.stats.map(function(s,idx){
      var m = s.num.match(/^(\D*)(\d+)(\D*)$/);
      var attrs = m ? ' data-count="'+m[2]+'" data-prefix="'+esc(m[1])+'" data-suffix="'+esc(m[3])+'" data-key="home-stat-'+idx+'"' : '';
      return '<div><div data-final="'+esc(s.num)+'"'+attrs+' style="font-family:var(--font-heading);font-weight:600;font-size:clamp(34px,3.4vw,50px);line-height:1;font-variant-numeric:tabular-nums">'+esc(s.num)+'</div><div style="font-size:12px;letter-spacing:.08em;text-transform:uppercase;color:color-mix(in srgb,var(--color-text) 66%,transparent);margin-top:12px">'+esc(s.label)+'</div></div>';
    }).join('')+'</div></div></section>'

   +'<section class="wrap reveal" style="padding-block:88px 24px"><div style="display:flex;align-items:flex-end;justify-content:space-between;gap:20px;flex-wrap:wrap;margin-bottom:40px">'
   +'<div><span class="kicker">'+esc(c.solHead.kicker)+'</span><h2 style="font-size:clamp(30px,3.4vw,42px);letter-spacing:-.02em;margin:18px 0 0;max-width:20ch">'+esc(c.solHead.title)+'</h2></div>'
   +'<a class="af-link arrow-link" href="#/solutions" style="font-weight:600;color:var(--color-accent)"><span>'+esc(c.solHead.viewAll)+'</span>'+ARROW_SVG+'</a></div>'
   +'<div class="grid-3">'+productsHtml+'</div></section>'

   +'<section class="wrap reveal" style="padding-block:72px 24px"><div class="hr-fade" style="margin-bottom:56px"></div>'
   +'<span class="kicker">'+esc(c.certHead.kicker)+'</span><h2 style="font-size:clamp(30px,3.4vw,42px);letter-spacing:-.02em;margin:18px 0 40px;max-width:22ch">'+esc(c.certHead.title)+'</h2>'
   +'<div class="grid-3">'+certsHtml+'</div></section>'

   +'<section class="wrap reveal" style="padding-block:72px 40px"><div style="display:flex;align-items:flex-end;justify-content:space-between;gap:20px;flex-wrap:wrap;margin-bottom:40px">'
   +'<div><span class="kicker">'+esc(c.projHead.kicker)+'</span><h2 style="font-size:clamp(30px,3.4vw,42px);letter-spacing:-.02em;margin:18px 0 0;max-width:20ch">'+esc(c.projHead.title)+'</h2></div>'
   +'<a class="af-link arrow-link" href="#/projects" style="font-weight:600;color:var(--color-accent)"><span>'+esc(c.projHead.viewAll)+'</span>'+ARROW_SVG+'</a></div>'
   +'<div class="af-scrollx" style="display:flex;gap:10px;margin-bottom:24px">'+homeTabsHtml+'</div>'
   +'<div class="grid-4">'+projHtml+'</div></section>'

   +'<section class="wrap reveal" style="padding-block:72px 8px"><div class="hr-fade" style="margin-bottom:56px"></div>'
   +'<div class="mop">'
   +'<div class="mop-amb" aria-hidden="true"><div class="g"></div>'+MOP_HEX+'<div class="orb orb-a"></div><div class="orb orb-b"></div></div>'
   +'<div class="mop-head"><span class="kicker">'+esc(c.milestones_t.kicker)+'</span>'
   +'<div style="display:flex;align-items:flex-end;justify-content:space-between;gap:20px;flex-wrap:wrap;margin:18px 0 44px"><h2 style="font-size:clamp(28px,3vw,40px);letter-spacing:-.02em;margin:0;max-width:22ch">'+esc(c.milestones_t.title)+'</h2><p style="font-size:15px;color:var(--color-neutral-300);max-width:46ch;margin:0">'+esc(c.milestones_t.sub)+'</p></div></div>'
   +'<div class="mop-tl" role="list" aria-label="'+esc(c.milestones_t.kicker)+'">'+MOP_ROUTE+MOP_ROUTE_M+mopHtml+'</div>'
   +'<div class="mop-foot"><span>'+esc(c.milestones_t.footL)+'</span><b>'+esc(c.milestones_t.footR)+'</b></div>'
   +'</div></section>'

   +'<section class="wrap reveal" style="padding-block:72px 8px"><div class="hr-fade" style="margin-bottom:56px"></div>'
   +'<div style="display:flex;align-items:flex-end;justify-content:space-between;gap:20px;flex-wrap:wrap;margin-bottom:18px"><div><span class="kicker">'+esc(c.customers_t.kicker)+'</span><h2 style="font-size:clamp(28px,3vw,40px);letter-spacing:-.02em;margin:18px 0 0;max-width:22ch">'+esc(c.customers_t.title)+'</h2></div>'
   +'<a class="af-link arrow-link" href="#/contractors" style="font-weight:600;color:var(--color-accent)"><span>'+esc(c.customers_t.viewAll)+'</span>'+ARROW_SVG+'</a></div>'
   +'<p style="font-size:15px;color:var(--color-neutral-300);max-width:46ch;margin:0 0 40px">'+esc(c.customers_t.sub)+'</p>'
   +'<div class="firmrow">'+contractorsHtml+'</div></section>'

   +'<section class="wrap reveal" style="padding-block:24px 8px">'
   +'<div style="display:flex;align-items:flex-end;justify-content:space-between;gap:20px;flex-wrap:wrap;margin-bottom:18px"><div><span class="kicker">'+esc(c.consultants_t.kicker)+'</span><h2 style="font-size:clamp(28px,3vw,40px);letter-spacing:-.02em;margin:18px 0 0;max-width:22ch">'+esc(c.consultants_t.title)+'</h2></div>'
   +'<a class="af-link arrow-link" href="#/consultants" style="font-weight:600;color:var(--color-accent)"><span>'+esc(c.consultants_t.viewAll)+'</span>'+ARROW_SVG+'</a></div>'
   +'<p style="font-size:15px;color:var(--color-neutral-300);max-width:46ch;margin:0 0 40px">'+esc(c.consultants_t.sub)+'</p>'
   +'<div class="firmrow">'+consultantsHtml+'</div></section>'

   +'<section class="wrap reveal" style="padding-block:40px 84px"><div class="card elev-md" style="border-radius:var(--radius-lg);padding:56px 44px;text-align:center;align-items:center;background:radial-gradient(700px 300px at 50% -20%,color-mix(in srgb,var(--color-accent) 16%,transparent),transparent 70%),var(--color-surface)">'
   +'<h2 style="font-size:clamp(26px,3vw,38px);letter-spacing:-.02em;margin:0 0 12px;max-width:22ch">'+esc(c.ctaBand.title)+'</h2>'
   +'<p style="font-size:16px;color:var(--color-neutral-300);max-width:52ch;margin:0 0 28px">'+esc(c.ctaBand.sub)+'</p>'
   +'<div style="display:flex;gap:14px;flex-wrap:wrap;justify-content:center">'
   +'<a class="btn btn-primary"'+QUOTE_ATTRS+' style="padding:12px 24px;font-size:15px">'+esc(b.cta.quote)+'</a>'
   +'<a class="btn btn-secondary" href="#/about" style="padding:12px 24px;font-size:15px">'+esc(c.ctaBand.learn)+'</a></div></div></section>'

   + renderFooter()
   +'</div>';
}

var PRODUCT_SPECS = {
  "clevis-hanger-ul-fm":{name:"Standard Clevis Hanger",
    page:12,
    usage:"To support insulated & non-insulated horizontal pipes",
    size:"3/4\" (20 mm) to 30\"(750 mm)",
    material:"Carbon steel EN 10111 DD11 (stainless steel can be used upon request)",
    finish:"Plain (black steel), zinc plated, or hot dip galvanized",
    approvals:"UL Listed, FM Approved",
    features:["Allow vertical adjustment for the hanger", "Allow small horizontal movements in the pipeline, without transferring it to the hanger suspended rod", "A 15° swing in either direction allows the pipe to easily feed through without being pinched during installation time", "Curved edges to facilitate handling and installation", "A pipe sleeve is installed over the cross bolt to prevent deformation of the clevis bottom under pipe weight (for sizes 8\" and bigger)"],
    compliance:["Complies with the FM standard: FM 1951, 1952, 1953 (December 2016)", "Completed with the Manufacturers Standardization Society MSS SP-58 Type 1", "Complies with UL 203 (Pipe hanger equipment for fire protection service)", "Complies with the National Fire Protection Association (NFPA) section"],
    notes:["The UL-listed sizes are ¾\" to 10\" only", "The FM-approved sizes are ¾\" to 4\" only", "Sizes (3/4\", 12\", 14\", 16\", 18\", 20\", 24\", 30\") are available upon request", "Hanger sizes less than 95 mm (3\") have an intermediate bolt and nut", "Hanger sizes greater than or equal to 95 mm (3\") have an intermediate threaded rod and 2 nuts", "Hanger Rod isn't included"],
    cols:["Part no", "inch", "mm", "D", "H", "A", "B", "M1 Rod", "M2 Cross rod", "Design Load (KN)"],
    rows:[["CHS_UL_FM-075_030", "3/4", "20", "30", "74.0", "25.5", "57.0", "M10", "M8", "3.66"], ["CHS_UL_FM-100_037", "1", "25", "37", "80.5", "25.0", "60.0", "M10", "M8", "3.66"], ["CHS_UL_FM-125_045", "1 1/4", "32", "45", "97.0", "33.5", "72.5", "M10", "M8", "3.66"], ["CHS_UL_FM-150_054", "1 1/2", "40", "54", "113.5", "41.0", "84.5", "M10", "M8", "3.66"], ["CHS_UL_FM-200_065", "2", "50", "65", "130.5", "46.0", "96.0", "M10", "M8", "3.66"], ["CHS_UL_FM-250_077", "2 1/2", "65", "77", "170.0", "62.0", "128.0", "M12", "M10", "5.35"], ["CHS_UL_FM-300_095", "3", "75", "95", "189.5", "63.0", "138.0", "M12", "M10", "5.35"], ["CHS_UL_FM-400_118", "4", "100", "118", "215.5", "66.0", "152.5", "M12", "M10", "10.2"], ["CHS_UL-500_145", "5", "125", "145", "249.5", "69.5", "173.0", "M12", "M12", "10.2"], ["CHS_UL-600_175", "6", "150", "175", "277.5", "70.0", "186.0", "M16", "M12", "16"], ["CHS_UL-800_225", "8", "200", "225", "340.0", "78.0", "223.5", "M16", "M16", "20"], ["CHS_UL-1000_278", "10", "250", "278", "404.0", "87.0", "261.0", "M20", "M16", "20"], ["CHS-1200_335", "12", "300", "335", "490.0", "85.0", "314.0", "M22", "M20", "20"], ["CHS-1400_365", "14", "350", "365", "531.0", "91.0", "341.0", "M24", "M22", "23.1"], ["CHS-1600_415", "16", "400", "415", "596.0", "104.0", "380.0", "M24", "M24", "23.1"], ["CHS-1800_470", "18", "450", "470", "670.0", "118.0", "425.0", "M24", "M27", "23.1"], ["CHS-2000_520", "20", "500", "520", "744.0", "127.0", "471.0", "M30", "M30", "37.2"], ["CHS-2400_620", "24", "600", "620", "869.0", "152.0", "546.0", "M30", "M30", "37.2"], ["CHS-3000_820", "30", "750", "820", "1123.0", "202.0", "700.0", "M30", "M30", "37.2"]]},
  "band-hanger-ul-fm":{name:"Standard Band Hanger (Swivel Ring)",
    page:14,
    usage:"To support insulated & non-insulated horizontal pipes",
    size:"3/4\" (20 mm) to 6\"(150 mm)",
    material:"Pre-galvanized Carbon steel, according to ASTM A653M",
    finish:"Plain (black steel), pre-galvanized, or hot dip galvanized",
    approvals:"UL Listed, FM Approved",
    features:["Allow vertical adjustment for the hanger", "With a swivel nut to facilitate the pipe installation"],
    compliance:["Complies with the FM standard: FM 1951, 1952, 1953 (December 2016)", "Complies with the Manufacturers Standardization Society MSS SP-58 Type 10", "Complies with the UL 203 (Pipe hanger equipment for fire protection service)", "Complies with the National Fire Protection Association (NFPA) section 13"],
    notes:["The UL-listed sizes are ¾\" to 2\" only (pre-galvanized)", "The FM-approved sizes are ¾\" to 2\" only", "Hanger rod is not included. Nominal pipe size Design Load Inch mm (KN)"],
    cols:["Part no", "inch", "mm", "D", "A", "B", "H", "M", "Design Load (KN)"],
    rows:[["SBH-035", "3/4", "20", "35.0", "52.5", "21.0", "72.0", "M10", "3.1"], ["SBH-038", "1", "25", "38.5", "62.0", "26.0", "83.0", "M10", "3.1"], ["SBH-045", "1 1/4", "32", "45.0", "66.0", "26.0", "90.5", "M10", "3.1"], ["SBH-059", "1 1/2", "40", "59.0", "70.0", "29.5", "101.0", "M10", "3.1"], ["SBH-065", "2", "50", "65.0", "84.0", "34.5", "118.5", "M10", "3.1"], ["SBH-077", "2 1/2", "65", "77", "91.7", "28.7", "134.7", "M10", "3.1"], ["SBH-095", "3", "75", "95", "116.4", "44.4", "168.4", "M12", "5.2"], ["SBH-120", "4", "100", "120", "116.4", "31.9", "181.9", "M12", "5.2"], ["SBH-145", "5", "125", "145", "143.2", "46.2", "221.2", "M12", "5.2"], ["SBH-175", "6", "150", "175", "171.0", "59.0", "264.0", "M12", "5.2"]]},
  "dsm-pipe-clamp":{name:"DSM Pipe Clamp with PVC Lining",
    page:15,
    usage:"To support vertical or horizontal pipelines",
    size:"From1/2\"(15 mm) to 6\" (150 mm)",
    material:"Cold-rolled carbon steel",
    finish:"Plain (black steel) or zinc plated",
    features:["Easy and safe assembly through a hex head Phillips bolt", "A PVC lining for noise insulation"],
    cols:["Part no", "inch", "mm", "D", "M2", "M1", "L", "H", "W", "Design Load (KN)"],
    rows:[["DSM-027", "½", "15", "20-22", "M6", "M8", "67", "38", "20", "1.63"], ["DSM-034", "¾", "20", "25-28", "M6", "M8", "74", "44", "20", "1.63"], ["DSM-040", "1", "25", "31-35", "M6", "M8", "80", "51", "20", "1.63"], ["DSM-047", "1 ¼", "32", "39-43", "M6", "M8", "88", "58", "20", "1.63"], ["DSM-056", "1 ½", "40", "48-51", "M6", "M8", "96", "67", "20", "1.63"], ["DSM-069", "2", "50", "60-64", "M6", "M8", "109", "80", "20", "1.63"], ["DSM-082", "2 ½", "65", "72-76", "M6", "M10", "122", "95", "20", "1.63"], ["DSM-095", "3", "80", "87-90", "M6", "M10", "136", "110", "25", "1.83"], ["DSM-120", "4", "100", "109-115", "M6", "M10", "161", "134", "25", "1.83"], ["DSM-174", "6", "150", "159-169", "M6", "M10", "216", "188", "25", "2.66"]]},
  "offset-pipe-clamp":{name:"Offset Pipe Clamp",
    page:19,
    usage:"To support pipelines running at a definite distance from the wall or floor. (Not to be used as a riser clamp)",
    size:"From 1/2\" (15 mm) to 8\"(200 mm)",
    material:"Carbon steel A36",
    finish:"Plain (black steel), zinc plating, or hot dip galvanized. Nominal pipe Inch mm",
    features:["The offsite distance 'C' can be customized according to the site need", "A PVC lining can be used to prevent electrolysis between the pipe (in case of copper tubes)&the clamp. Also, it acts to reduce noise and vibration in pipe or tubing systems"],
    cols:["Part no", "inch", "mm", "D", "A", "B", "C", "E", "H", "L", "M"],
    rows:[["OPC-023", "1/2", "15", "19-23", "152", "67", "65.5", "11", "81", "183", "M10"], ["OPC-029", "3/4", "20", "23-29", "158", "73", "68.5", "11", "87", "189", "M10"], ["OPC-035", "1", "25", "30-35", "164", "79", "71.5", "11", "93", "195", "M10"], ["OPC-043", "1 1/4", "32", "37-43", "172", "87", "75.5", "11", "101", "203", "M10"], ["OPC-052", "1 1/2", "40", "46-52", "181", "96", "80", "11", "110", "212", "M10"], ["OPC-064", "2", "50", "58-64", "213", "118", "86", "11", "122", "244", "M10"], ["OPC-076", "2 1/2", "65", "70-76", "225", "130", "92", "11", "134", "256", "M10"], ["OPC-092", "3", "80", "87-92", "241", "146", "100", "11", "150", "272", "M10"], ["OPC-119", "4", "100", "112-119", "276", "173", "115.5", "13", "181", "309", "M12"], ["OPC-143", "5", "125", "137-143", "300", "197", "127.5", "13", "205", "333", "M12"], ["OPC-173", "6", "150", "166-173", "370", "247", "142.5", "13", "235", "403", "M12"], ["OPC-220", "8", "200", "214-220", "417", "294", "166", "13", "282", "450", "M12"]]},
  "riser-clamp-fm":{name:"Standard Riser Clamp",
    page:20,
    usage:"To support and stabilize vertical pipes runs",
    size:"From 1/2\" (15 mm) to 24\"(600 mm)",
    material:"Carbon steel A36",
    finish:"Plain (black steel), zinc plated, or hot-dip galvanized",
    approvals:"FM Approved",
    features:["The riser clamp is preferably installed below a coupling hub or field welded shear lugs", "The riser clamp has long wings to transfer the riser's load to the floor or to the ceiling", "Rounded ends provide greater safety for personnel", "A PVC lining can be used to prevent contact between the pipe & the clamp (in the case of copper pipes)"],
    compliance:["Complies with the FM standard: FM 1951, 1952, 1953 (December 2016)", "Meets the Manufacturers Standardization Society MSS SP-58 Type 8 and NFPA 13"],
    notes:["The FM approved sizes are 2\" to 8\" only"],
    cols:["Part no", "inch", "mm", "D", "A", "B", "C", "H", "L", "M", "Recommended Torque (N.m)"],
    rows:[["RCS-025", "1/2", "15", "20-25", "69", "12", "7", "38", "211", "M10", "15"], ["RCS-028", "3/4", "20", "25-28", "72", "12", "7", "41", "214", "M10", "15"], ["RCS-038", "1", "25", "32-38", "82", "12", "7", "51", "224", "M10", "15"], ["RCS-045", "1 1/4", "32", "40-45", "91", "12", "7", "60", "243", "M10", "15"], ["RCS-055", "1 1/2", "40", "48-55", "101", "12", "7", "70", "253", "M10", "15"], ["RCS-067", "2", "50", "60-67", "113", "12", "7", "82", "265", "M10", "15"], ["RCS-075", "2 1/2", "65", "70-75", "127", "14", "10", "93", "273", "M12", "15"], ["RCS-095", "3", "80", "88-95", "147", "14", "10", "113", "303", "M12", "15"], ["RCS-120", "4", "100", "110-120", "176", "14", "10", "142", "332", "M12", "68"], ["RCS-145", "5", "125", "140-145", "201", "14", "12", "169", "357", "M12", "68"], ["RCS-175", "6", "150", "160-175", "237", "17", "12", "199", "407", "M16", "70"], ["RCS-225", "8", "200", "210-225", "291", "17", "12", "253", "461", "M16", "70"], ["RCS-280", "10", "250", "270-280", "346", "17", "12", "308", "516", "M16", "70"], ["RCS-330", "12", "300", "315-330", "400", "17", "12", "362", "580", "M16", "70"]]},
  "wooden-support":{name:"Flat-Bottom Insulation Wood Frame",
    page:25,
    usage:"Prevents the crushing of insulation of insulated pipes at the point of support",
    size:"From 1/2\" (15 mm) to 36\"(900 mm). • Contact us about other sizes",
    material:"Beech pine wood, • Beech wood, • or Pine wood",
    finish:"Painted with wood sealer (transparent or red), • Epoxy, • or Fire-retardant coating. • U-bolt: Zinc plated, or Hot dip galvanized",
    features:["Protects the pipe's insulation at the point of support", "Good insulation material", "Can be customized according to insulation thickness"],
    notes:["The dimension \"I\" = 50 mm (2\") as standard, but can be changed according to the insulation thickness Nominal inch mm"],
    cols:["Part no", "inch", "mm", "D", "W", "U-bolt", "U", "H=L"],
    rows:[["WFF-023/50", "1/2", "15", "22", "40", "M8", "12", "122"], ["WFF-029/50", "3/4", "20", "27", "40", "M8", "12", "127"], ["WFF-035/50", "1", "25", "34", "40", "M8", "12", "134"], ["WFF-043/50", "1 1/4", "32", "42", "40", "M8", "12", "142"], ["WFF-050/50", "1 1/2", "40", "49", "40", "M8", "12", "149"], ["WFF-063/50", "2", "50", "61", "40", "M8", "12", "161"], ["WFF-075/50", "2 1/2", "65", "73", "50", "M10", "12", "173"], ["WFF-090/50", "3", "75", "89", "50", "M10", "12", "189"], ["WFF-116/50", "4", "100", "115", "50", "M10", "12", "215"], ["WFF-142/50", "5", "125", "142", "50", "M10", "12", "242"], ["WFF-170/50", "6", "150", "169", "50", "M10", "14", "269"], ["WFF-220/50", "8", "200", "220", "50", "M10", "14", "320"], ["WFF-275/50", "10", "250", "273", "50", "M10", "14", "373"], ["WFF-325/50", "12", "300", "324", "50", "M10", "14", "424"], ["WFF-358/50", "14", "350", "356", "75", "M12", "14", "456"], ["WFF-358/50", "16", "400", "407", "75", "M12", "18", "507"], ["WFF-358/50", "18", "450", "458", "75", "M12", "18", "558"], ["WFF-358/50", "20", "500", "510", "75", "M12", "18", "610"]]},
  "beam-clamp-type-a":{name:"Beam Clamp Type A",
    page:26,
    usage:"To attach a vertical rod to the flange of a beam where it is required to be offset from the edge of the flange",
    size:"From 8 to 10 mm threaded rods",
    material:"Carbon steel A36",
    finish:"Zinc plated, or hot-dip galvanized. Design Load (KN)",
    features:["It may be attached to horizontal flanges of structural members in either the top beam or bottom beam positions", "Maximum beam's flange thickness 20mm", "Secured in place by a cup-pointed Set Screw tightened against the flange", "Permits unlimited vertical rod adjustment", "The open design permits inspection of thread engagement"],
    compliance:["Complies with the Manufacturers Standardization Society MSS SP-58 Type 19"],
    cols:["Part no", "M1", "M2", "Design Load (KN)"],
    rows:[["BCA-008", "M8", "M8", "2.35"], ["BCA-010", "M10", "M10", "2.35"]]},
  "beam-clamp-type-b":{name:"Beam Clamp Type B",
    page:27,
    usage:"To attach a vertical rod to the flange of a beam where it is required to be offset from the edge of the flange",
    material:"Carbon steel A36 (stainless steel can be used upon request)",
    finish:"Zinc plated, or hot-dip galvanized. Design Load (KN)",
    features:["It may be attached to flanges of structural members in either the top beam or bottom beam positions", "Maximum beam's flange thickness 17.5 mm", "Secured in place by a Set Screw tightened against the flange with a locknut", "It has two positions for the attached rod, a zero-moment position and the offset position", "Permits unlimited vertical rod adjustment in the offset position", "The open design permits inspection of thread engagement. Sizes: 10 & 12 & 16 mm threaded rod"],
    compliance:["Complies with the Manufacturers Standardization Society MSS SP-58 Type 19"],
    cols:["Part no", "M1", "M2", "Design Load (KN)"],
    rows:[["BCB-010", "M10", "M10", "2.35"], ["BCB-012", "M12", "M12", "2.35"], ["BCB-016", "M16", "M16", "2.35"]]},
  "beam-clamp-for-pipe":{name:"Beam Clamp for Pipes",
    page:28,
    usage:"To attach horizontal pipes to the flange of a beam",
    size:"From 1/2\" (15 mm) to 4\"(100 mm)",
    material:"Carbon steel A36 (stainless steel can be used upon request)",
    finish:"Zinc plated, or hot-dip galvanized. Nominal pipe size inch mm",
    features:["Reduce installation time due to its simplicity", "Maximum beam's flange thickness 20 mm", "Always used in pairs"],
    cols:["Part no", "inch", "mm", "D", "A", "B", "H", "M"],
    rows:[["BCC-025", "½", "15", "25", "33", "64", "59.8", "M8"], ["BCC-030", "¾", "20", "30", "38", "69", "67.0", "M8"], ["BCC-038", "1", "25", "38", "46", "77", "74.2", "M8"], ["BCC-046", "1 ¼", "32", "46", "54", "85", "83.9", "M8"], ["BCC-054", "1 ½", "40", "54", "62", "93", "97.2", "M8"], ["BCC-064", "2", "50", "64", "72", "103", "112.9", "M8"], ["BCC-082", "2 ½", "65", "82", "92", "125", "130.6", "M10"], ["BCC-094", "3", "75", "94", "104", "137", "146.3", "M10"], ["BCC-120", "4", "100", "120", "130", "163", "172.8", "M10"]]},
  "beam-clamp-for-sam-strut-channel":{name:"Beam Clamp for SAM Strut Channels",
    page:29,
    usage:"To attach different SAM strut channels to the flange of a beam",
    material:"Carbon steel A36 (stainless steel can be used upon request)",
    finish:"Zinc plated, or hot-dip galvanized. Square U-bolt part no Used with SAM strut channel with a height of 39.6 mm Or a double channel with a height of 19.6 m back to back",
    features:["Reduce installation time due to its simplicity", "Always used in pairs", "Steel size: 85x4 mm", "Max flange thickness 29 mm"],
    cols:["Part no", "H", "SAM strut channel", "Usage"],
    rows:[["BCSC-063", "63", "SUB-085", "Used with SAM strut channel with a height of 19.6 mm"], ["BCSC-083", "83", "SUB-105", "Used with SAM strut channel with a height of 39.6 mm"], ["BCSC-123", "123", "SUB-145", "Used with SAM strut double channel with a height of 39.6 mm back to back"]]},
  "sam-strut-channel":{name:"SAM Strut Channels",
    page:30,
    usage:"Main elements in the SAM strut framing system, used as support elements",
    material:"Carbon steel A36 (stainless steel can be used upon request)",
    finish:"Plain (black steel), zinc plated, or hot-dip galvanized",
    features:["Save installation time", "Simple & easy to use", "Available length: 2.5 & 3 meters", "Available in slotted & blank type"],
    cols:["Part no", "Type", "Double/Single", "Blank/Slotted", "L", "H", "A", "Thickness", "Standard length"],
    rows:[["SAMCSB-4040-A-3000", "A", "Single", "Blank", "41.6", "39.6", "20", "2", "3000"], ["SAMCSB-4020-A-3000", "A", "Single", "Blank", "41.6", "19.6", "20", "2", "3000"], ["SAMCSS-4040-A-3000", "A", "Single", "Slotted", "41.6", "39.6", "20", "2", "3000"], ["SAMCSS-4020-A-3000", "A", "Single", "Slotted", "41.6", "19.6", "20", "2", "3000"], ["SAMCSB-4040-B-3000", "B", "Single", "Blank", "41.6", "39.6", "21.3", "2", "3000"], ["SAMCSB-4020-B-3000", "B", "Single", "Blank", "41.6", "19.6", "21.3", "2", "3000"], ["SAMCSS-4040-B-3000", "B", "Single", "Slotted", "41.6", "39.6", "21.3", "2", "3000"], ["SAMCSS-4020-B-3000", "B", "Single", "Slotted", "41.6", "19.6", "21.3", "2", "3000"], ["SAMCDB-4080-A-3000", "A", "Double", "Blank", "41.6", "79.2", "20", "2", "3000"], ["SAMCDB-4040-A-3000", "A", "Double", "Blank", "41.6", "39.2", "20", "2", "3000"], ["SAMCDB-4080-B-3000", "B", "Double", "Blank", "41.6", "79.2", "21.3", "2", "3000"], ["SAMCDB-4040-B-3000", "B", "Double", "Blank", "41.6", "39.2", "21.3", "2", "3000"]]},
  "bracket":{name:"SAM Strut Accessories",
    page:33,
    usage:"To be used with the SAM strut channels to provide different solutions for electrical, mechanical and industrial supports",
    material:"Carbon steel A36 (stainless-steel can be used upon request)",
    finish:"Plain (black steel), zinc plated, or hot-dip galvanized",
    features:["Installs quickly, saves time", "Many parts, giving the flexibility and creativity to construct the needed support frames according to actual situation", "No welding is needed", "No drilling is needed"]},
  "pipe-clamp-on-sam-channel":{name:"Pipe Clamp on SAM Strut Channels",
    page:39,
    usage:"To support EMT, IMC, GRC conduit and cables to SAM strut channels",
    size:"From 1/2\" (15 mm) to 4\"(100 mm)",
    material:"Carbon steel A36 (stainless steel can be used upon request)",
    finish:"Plain (black steel), zinc plated, or hot-dip galvanized. Nominal pipe size inch mm",
    features:["Save installation time", "Can be used with different SAM strut channel sizes"],
    cols:["Part no", "inch", "mm", "D", "H", "M", "Steel size"],
    rows:[["SAM2-022", "½", "15", "17-22", "44", "M6x20", "30x2"], ["SAM2-027", "¾", "20", "23-27", "50", "M6x20", "30x2"], ["SAM2-034", "1", "25", "29-34", "56", "M6x20", "30x2"], ["SAM2-043", "1 ¼", "32", "38-43", "65", "M6x20", "30x2"], ["SAM2-049", "1 ½", "40", "44-49", "71", "M6x20", "30x2"], ["SAM2-061", "2", "50", "55-61", "82", "M6x20", "30x2"], ["SAM2-075", "2 ½", "60", "72-75", "99", "M6x20", "30x2"], ["SAM2-090", "3", "75", "87-90", "114", "M6x20", "30x2"], ["SAM2-115", "4", "100", "112-115", "139", "M6x20", "30x2"]]},
  "threaded-rod":{name:"Threaded Rod",
    page:40,
    usage:"General use in supports",
    size:"From M6 to M24",
    material:"Carbon steel A36 (stainless steel can be used upon request)",
    finish:"Plain (black steel), zinc plated. Design Load (KN)",
    features:["Standard length 2 m", "Length can be customized according to the need"],
    cols:["Part no", "M", "Pitch", "Length", "Design Load (KN)"],
    rows:[["THR-006", "M6", "1", "2000", "1.4"], ["THR-008", "M8", "1.2", "2000", "2.4"], ["THR-010", "M10", "1.5", "2000", "3.65"], ["THR-012", "M12", "1.75", "2000", "5.35"], ["THR-014", "M14", "2", "2000", "7.72"], ["THR-016", "M16", "2", "2000", "10.2"], ["THR-018", "M18", "2.5", "2000", "12.9"], ["THR-020", "M20", "2.5", "2000", "16"], ["THR-022", "M22", "2.5", "2000", "20.1"], ["THR-024", "M24", "3", "2000", "23.1"]]},
  "fixation-set":{name:"Double-Thread Screw",
    page:41,
    usage:"Allow the installation of different support elements to the wall using a woodscrew thread and a suitable wall plug",
    size:"From M6 to M10",
    material:"Carbon steel A36",
    finish:"Plain (black steel), Zinc plating",
    features:["Length can be customized according to the need"],
    cols:["Part no", "M", "d", "L", "L1", "L2"],
    rows:[["DTS-08080", "M8", "8", "80", "25", "40"], ["DTS-10100", "M10", "10", "100", "25", "55"]]},
  "u-bolt":{name:"Standard U-Bolt",
    page:44,
    usage:"Fix, support, or guide pipes to support elements and channels",
    size:"From 1/2\" (15 mm) to 16\"(400 mm)",
    material:"Carbon steel A36 (stainless steel can be used upon request)",
    finish:"Plain (black steel), zinc plated, or hot dip galvanized",
    features:["Considered as an easy & time-saving element"],
    compliance:["Complies with the Manufacturers Standardization Society MSS SP-58 Type 24", "The nuts comply with DIN 934 and ASTM A563"],
    notes:["The MSS compliant sizes are 2 ½\" to 10\" only", "MSS compliant ½\" to 2\" are available upon request", "Sizes larger than 10\" are available upon request. Nominal pipe D (Max pipe O.D) Inch mm"],
    cols:["Part no", "inch", "mm", "D (Max pipe O.D)", "A", "B", "C", "H", "L", "M"],
    rows:[["UBS-025", "½", "15", "25", "33", "45", "8", "60", "41", "M8"], ["UBS-030", "¾", "20", "30", "38", "45", "8", "78", "46", "M8"], ["UBS-035", "1", "25", "35", "43", "45", "8", "83", "51", "M8"], ["UBS-045", "1 ¼", "32", "45", "53", "45", "8", "93", "61", "M8"], ["UBS-055", "1 ½", "40", "55", "63", "45", "8", "103", "71", "M8"], ["UBS-065", "2", "50", "65", "73", "45", "8", "113", "81", "M8"], ["UBS-082", "2 ½", "65", "82", "92", "50", "10", "137", "102", "M10"], ["UBS-094", "3", "75", "94", "104", "50", "10", "149", "114", "M10"], ["UBS-120", "4", "100", "120", "130", "50", "10", "175", "140", "M10"], ["UBS-145", "5", "125", "145", "155", "50", "10", "200", "165", "M10"], ["UBS-175", "6", "150", "175", "187", "60", "12", "242", "199", "M12"], ["UBS-225", "8", "200", "225", "237", "60", "12", "292", "249", "M12"], ["UBS-280", "10", "250", "280", "296", "65", "16", "356", "312", "M16"]]},
  "u-bolt-pvc-hose":{name:"Standard U-Bolt with PVC Hose",
    page:45,
    usage:"Fix, support, or guide pipes to support elements and PVC channels. hose",
    size:"From 1/2\" (15 mm) to 10\"(250 mm)",
    material:"Carbon steel A36 (stainless steel can be used upon request)",
    finish:"Plain (black steel), zinc plated, or hot dip galvanized",
    features:["Considered as an easy & time-saving element"],
    compliance:["Complies with the Manufacturers Standardization Society SP-58 Type 24", "The nuts comply with DIN 934 and ASTM A563"],
    notes:["The MSS compliant sizes are 2 ½\" to 10\" only", "MSS compliant ½\" to 2\" are available upon request", "Sizes larger than 10\" are available upon request. Nominal pipe Pipe D O.D (Max pipe O.D) Inch mm"],
    cols:["Part no", "inch", "mm", "Pipe O.D", "D (Max pipe O.D)", "A", "B", "C", "H", "L", "M"],
    rows:[["UBSP-025", "1/2", "15", "21.3", "24", "33", "45", "8", "72", "41", "M8"], ["UBSP-030", "3/4", "20", "26.7", "29", "38", "45", "8", "78", "46", "M8"], ["UBSP-038", "1", "25", "33.4", "37", "46", "45", "8", "85", "54", "M8"], ["UBSP-046", "1 1/4", "32", "42.1", "45", "54", "45", "8", "94", "62", "M8"], ["UBSP-054", "1 1/2", "40", "48.2", "53", "62", "45", "8", "103", "70", "M8"], ["UBSP-064", "2", "50", "60.3", "63", "72", "45", "8", "112", "80", "M8"], ["UBSP-082", "2 1/2", "65", "73", "81", "92", "50", "10", "131", "102", "M10"], ["UBSP-094", "3", "75", "88.9", "93", "104", "50", "10", "145", "114", "M10"], ["UBSP-120", "4", "100", "114.3", "119", "130", "50", "10", "171", "140", "M10"], ["UBSP-148", "5", "125", "141.3", "147", "158", "50", "10", "202", "168", "M10"], ["UBSP-176", "6", "150", "168.3", "175", "188", "60", "12", "231", "200", "M12"], ["UBSP-228", "8", "200", "219.1", "227", "240", "60", "12", "282", "252", "M12"], ["UBSP-282", "10", "250", "273", "281", "298", "65", "16", "344", "314", "M16"]]},
  "drop-in-anchor":{name:"Mechanical Anchor (Drop-In Anchor)",
    page:46,
    usage:"For permanently fixing threaded rods in concrete and good-quality stone",
    size:"From M6 to M16",
    material:"Carbon steel A36",
    finish:"Zinc plated",
    features:["Ideal for secure fixing for mechanical services, cable trays, platforms, drain covers, suspended ceilings, etc", "Allows bolts or studs to be installed and removed without damaging the anchor"]},
};

var PRODUCT_T = {
  en:{back:'All solutions', usage:'Application', features:'Features', size:'Size range',
      material:'Material', finish:'Finish', compliance:'Standards & compliance',
      approvals:'Approvals', notes:'Notes', sizes:'Sizes & part numbers',
      partno:'Part No.', inch:'Nominal size (inch)', mm:'Nominal size (mm)',
      cta:'Need load ratings or a bill of materials?',
      ctaSub:'Send us the size, finish and quantity - our team replies with a quotation within one business day.',
      related:'More in this category', catRef:'Catalogue page'}
};



/* Finish selection and ordering, from the catalogue's technical-data pages.
   Each product only shows the finishes its own data sheet lists. */
var FINISHES = {
  B:{code:'B',
     en:{name:'Plain (black steel)', std:'Uncoated',
         thick:'No coating', use:'Where the support is painted on site or sits inside a protected, dry enclosure.'}},
  Z:{code:'Z',
     en:{name:'Zinc plated', std:'ASTM B633',
         thick:'7-15 \u00b5m', use:'Recommended for indoor use in relatively dry areas. Smooth, bright finish.'}},
  P:{code:'P',
     en:{name:'Pre-galvanized', std:'Z275 sheet',
         thick:'~13.5 \u00b5m per side', use:'Dry or mildly corrosive atmospheres. Not recommended outdoors in industrial environments.'}},
  H:{code:'H',
     en:{name:'Hot-dip galvanized after fabrication', std:'ASTM A123',
         thick:'36-100 \u00b5m', use:'Recommended for outdoor exposure. Coats every surface including cut edges.'}}
};

var ORDER_T = {
  en:{ title:'Application & ordering',
       lead:'Pick the finish that suits the environment, then build the part number.',
       figCap:'Shown in application',
       finishHead:'Choosing a finish',
       thick:'Coating', std:'Standard', where:'Where to use',
       liningHead:'PVC lining',
       lining:'The PVC lining keeps the pipe from touching the clamp body, which avoids electrolysis with copper tube. It is also non-flammable, so it can be used on fire-fighting hangers and clamps.',
       orderHead:'How to order',
       orderLead:'A full part number is the data-sheet number, then the finish, then the lining and material if they apply.',
       ex:'Example', exNote:'the size from the table above, hot-dip galvanized',
       codeFinish:'Finish', codeLining:'Lining', codeMaterial:'Material',
       liningCodes:'B - black PVC \u00b7 G - green PVC \u00b7 R - rubber',
       matCodes:'CS - carbon steel \u00b7 A2 - stainless 304 \u00b7 A4 - stainless 316 \u00b7 BW - beech wood \u00b7 BP - beech pine \u00b7 CU - copper' }
};

/* catalogue pictorial-index figure: the product shown in application */
var APP_FIG = {
  'clevis-hanger-ul-fm':1,'band-hanger-ul-fm':1,'dsm-pipe-clamp':1,'offset-pipe-clamp':1,
  'riser-clamp-fm':1,'wooden-support':1,'beam-clamp-type-a':1,'beam-clamp-type-b':1,
  'beam-clamp-for-pipe':1,'beam-clamp-for-sam-strut-channel':1,'sam-strut-channel':1,
  'bracket':1,'pipe-clamp-on-sam-channel':1,'threaded-rod':1,'fixation-set':1,'u-bolt':1,
  'u-bolt-pvc-hose':1,'drop-in-anchor':1
};
var APP_FIG_ALIAS = { 'riser-clamp-pvc-fm':'riser-clamp-fm' };
function appFigFor(slug){
  var k = APP_FIG[slug] ? slug : APP_FIG_ALIAS[slug];
  return (k && APP_FIG[k]) ? 'fig-'+k+'.png' : '';
}

/* which finishes this product's own data sheet lists */
function finishesFor(spec){
  var t = ((spec && spec.finish) || '').toLowerCase();
  var out = [];
  if(/plain|black steel/.test(t))                 out.push(FINISHES.B);
  if(/zinc plated|zinc-plated/.test(t))           out.push(FINISHES.Z);
  if(/pre-galvanized|pre galvanized/.test(t))     out.push(FINISHES.P);
  if(/hot[- ]dip/.test(t))                        out.push(FINISHES.H);
  return out;
}

function hasLining(slug, spec){
  var hay = (slug + ' ' + ((spec && spec.usage) || '') + ' ' + ((spec && spec.name) || '')).toLowerCase();
  return /pvc|lining/.test(hay);
}

function productSlug(img){ return (img||'').replace(/^prod-/,'').replace(/\.(jpg|png|jpeg)$/,''); }
/* Products that exist as real Shopify pages link to the crawlable URL;
   the rest stay on the in-app route. */
var AFX_REAL_PRODUCTS = ["band-hanger-ul-fm", "beam-clamp-for-pipe", "beam-clamp-for-sam-strut-channel", "beam-clamp-type-a", "beam-clamp-type-b", "bracket", "clevis-hanger-ul-fm", "drop-in-anchor", "dsm-pipe-clamp", "fixation-set", "offset-pipe-clamp", "pipe-clamp-on-sam-channel", "riser-clamp-fm", "riser-clamp-pvc-fm", "sam-strut-channel", "threaded-rod", "u-bolt", "u-bolt-pvc-hose", "wooden-support"];
function productHref(img){
  var slug = productSlug(img);
  return (AFX_REAL_PRODUCTS.indexOf(slug) >= 0) ? ('/products/' + slug) : ('#/product/' + slug);
}

function findProduct(slug){
  var cats = SOLUTIONS[t()].cats;
  for(var i=0;i<cats.length;i++){
    var sub = cats[i].sub;
    for(var j=0;j<sub.length;j++){
      if(productSlug(sub[j].img) === slug) return {cat:cats[i], catIdx:i, item:sub[j]};
    }
  }
  return null;
}

function productTile(s){
  var photo = s.fit === 'cover';
  var tile  = photo ? 'var(--color-accent-900)' : (s.bg || 'radial-gradient(circle at 50% 40%,#eef1f5,#c9d0d8)');
  var img = s.img
    ? '<img src="'+I(s.img)+'" alt="'+esc(s.name)+'" loading="lazy" style="'
      + (photo ? 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover'
               : 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain')+'">'
    : '<div style="position:absolute;inset:18px;display:grid;place-items:center;color:var(--color-neutral-600);font-size:12px;text-align:center">'+esc(s.name)+'</div>';
  return '<a class="card af-prod elev-sm" href="'+productHref(s.img)+'" style="padding:0;overflow:hidden;border-radius:var(--radius-lg);text-decoration:none">'
    +'<div style="position:relative;aspect-ratio:1/1;background:'+tile+'">'+img+'</div>'
    +'<div style="padding:16px 16px 18px"><h3 style="font-size:14px;line-height:1.25;margin:0;text-transform:uppercase;letter-spacing:.04em;color:var(--color-accent)">'+esc(s.name)+'</h3></div></a>';
}

function renderProduct(){
  var slug = state.product;
  var hit  = findProduct(slug);
  var L    = PRODUCT_T[t()];
  // the PVC-lined riser clamp shares the standard riser clamp's catalogue sheet
  var SPEC_ALIAS = {'riser-clamp-pvc-fm':'riser-clamp-fm'};
  var spec = PRODUCT_SPECS[slug] || PRODUCT_SPECS[SPEC_ALIAS[slug]];
  if(!hit) return renderSolutions();
  var item = hit.item, cat = hit.cat;
  var photo = item.fit === 'cover';
  var tile  = photo ? 'var(--color-accent-900)' : (item.bg || 'radial-gradient(circle at 50% 40%,#eef1f5,#c9d0d8)');
  var imgCss = photo ? 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover'
                     : 'position:absolute;inset:6%;width:88%;height:88%;object-fit:contain';

  function facts(){
    var f = [];
    if(spec && spec.size)     f.push([L.size, spec.size]);
    if(spec && spec.material) f.push([L.material, spec.material]);
    if(spec && spec.finish)   f.push([L.finish, spec.finish]);
    if(!f.length) return '';
    return '<dl class="pd-facts">'+f.map(function(x){
      return '<div><dt>'+esc(x[0])+'</dt><dd>'+esc(x[1])+'</dd></div>'; }).join('')+'</dl>';
  }
  function list(title, arr, tick){
    if(!arr || !arr.length) return '';
    return '<section class="pd-block"><h2>'+esc(title)+'</h2><ul class="pd-list'+(tick?' pd-list--tick':'')+'">'
      + arr.map(function(x){ return '<li>'+esc(x)+'</li>'; }).join('') + '</ul></section>';
  }
  var approvals = (spec && spec.approvals) ? '<div class="pd-appr">'
      + spec.approvals.split(',').map(function(a){ return '<span class="pd-badge">'+esc(a.trim())+'</span>'; }).join('')
      + '</div>' : '';

  /* Every product prints a different set of columns - design loads, torques,
     pitches, steel sizes - so the header comes from the product's own data
     rather than a fixed Part no / inch / mm shape. */
  var sizes = '';
  if(spec && spec.rows && spec.rows.length && spec.cols){
    var cols = spec.cols;
    var pipe = cols.indexOf('inch');
    var head = cols.map(function(c, n){
      if(n === pipe)     return '<th>'+esc(L.inch)+'</th>';
      if(n === pipe + 1 && c === 'mm') return '<th>'+esc(L.mm)+'</th>';
      if(n === 0)        return '<th>'+esc(L.partno)+'</th>';
      return '<th>'+esc(c)+'</th>';
    }).join('');
    sizes = '<section class="pd-block"><h2>'+esc(L.sizes)+'</h2>'
      +'<div class="af-scrollx pd-tablewrap"><table class="pd-table"><thead><tr>'+head+'</tr></thead><tbody>'
      + spec.rows.map(function(r){
          return '<tr>'+r.map(function(v, n){
            return n === 0 ? '<td class="pd-pn">'+esc(v)+'</td>' : '<td>'+esc(v)+'</td>';
          }).join('')+'</tr>';
        }).join('')
      +'</tbody></table></div></section>';
  }


  // ---- application & ordering -------------------------------------------
  function applyBlock(){
    var O  = ORDER_T[t()];
    var fs = finishesFor(spec);
    if(!fs.length && !spec) return '';
    var lang = t();
    var cards = fs.map(function(f){
      var d = f[lang];
      return '<div class="pd-fin">'
        +'<div class="pd-fin__top"><span class="pd-fin__code">'+esc(f.code)+'</span>'
        +'<h4>'+esc(d.name)+'</h4></div>'
        +'<dl><div><dt>'+esc(O.std)+'</dt><dd>'+esc(d.std)+'</dd></div>'
        +'<div><dt>'+esc(O.thick)+'</dt><dd>'+esc(d.thick)+'</dd></div></dl>'
        +'<p>'+esc(d.use)+'</p></div>';
    }).join('');

    // worked example built from this product's own first part number
    var pn = (spec && spec.rows && spec.rows.length) ? spec.rows[0][0] : '';
    var ex = '';
    if(pn){
      var suffix = fs.length ? fs[fs.length-1].code : 'H';
      var full = pn + '-' + suffix + (hasLining(slug, spec) ? '-B' : '');
      ex = '<div class="pd-order__ex"><span class="pd-order__exlab">'+esc(O.ex)+'</span>'
         + '<code>'+esc(full)+'</code>'
         + '<span class="pd-order__exnote">'+esc(O.exNote)+'</span></div>';
    }

    var codes = '<div class="pd-codes">'
      +'<div><dt>'+esc(O.codeFinish)+'</dt><dd>'
      + fs.map(function(f){ return esc(f.code)+' - '+esc(f[lang].name); }).join(' \u00b7 ')
      +'</dd></div>'
      + (hasLining(slug, spec) ? '<div><dt>'+esc(O.codeLining)+'</dt><dd>'+esc(O.liningCodes)+'</dd></div>' : '')
      +'<div><dt>'+esc(O.codeMaterial)+'</dt><dd>'+esc(O.matCodes)+'</dd></div>'
      +'</div>';

    var fig = appFigFor(slug);
    // the official UL / FM marks, shown when this product's data sheet lists them
    var ap  = ((spec && spec.approvals) || '').toLowerCase();
    var marks = '';
    if(ap.indexOf('ul') >= 0) marks += '<span class="pd-mark"><img src="'+I('mark-ul.png')+'" alt="UL Listed" loading="lazy"></span>';
    if(ap.indexOf('fm') >= 0) marks += '<span class="pd-mark"><img src="'+I('mark-fm.png')+'" alt="FM Approved" loading="lazy"></span>';
    var figHtml = fig ? '<figure class="pd-fig"><div class="pd-fig__panel">'
        + (marks ? '<div class="pd-marks'+(marks.indexOf('mark-ul')<0?' pd-marks--one':'')+'">'+marks+'</div>' : '')
        +'<img src="'+I(fig)+'" alt="'+esc(item.name)+'" loading="lazy">'
        +'</div><figcaption>'+esc(O.figCap)+'</figcaption></figure>' : '';

    return '<section class="pd-block pd-apply"><h2>'+esc(O.title)+'</h2>'
      +'<p class="pd-lead">'+esc(O.lead)+'</p>'
      +'<div class="pd-apply__grid">'+figHtml+'<div class="pd-apply__body">'
      + (cards ? '<h3 class="pd-sub">'+esc(O.finishHead)+'</h3><div class="pd-fins">'+cards+'</div>' : '')
      + (hasLining(slug, spec) ? '<h3 class="pd-sub">'+esc(O.liningHead)+'</h3><p class="pd-note">'+esc(O.lining)+'</p>' : '')
      +'<h3 class="pd-sub">'+esc(O.orderHead)+'</h3>'
      +'<p class="pd-note">'+esc(O.orderLead)+'</p>'
      + ex + codes
      +'</div></div></section>';
  }

  var related = cat.sub.filter(function(x){ return productSlug(x.img) !== slug; }).slice(0,5);
  var relHtml = related.length ? '<section class="wrap reveal" style="padding-block:24px 84px">'
      +'<div class="hr-fade" style="margin-bottom:40px"></div>'
      +'<h2 style="font-size:clamp(20px,2.2vw,26px);margin:0 0 22px">'+esc(L.related)+'</h2>'
      +'<div class="grid-4">'+related.map(productTile).join('')+'</div></section>' : '';

  return ''
   +'<div class="page-bg">'+renderHeader('products')
   +'<section class="wrap reveal" style="padding-block:34px 0">'
   +'<nav class="pd-crumb"><a href="#/solutions">'+esc(L.back)+'</a><span>/</span>'
   +'<a href="#/solutions/'+hit.catIdx+'">'+esc(cat.name)+'</a></nav></section>'
   +'<section class="wrap reveal pd-top" style="padding-block:22px 10px">'
   +'<div class="pd-shot" style="background:'+tile+'">'
   + (item.img ? '<img src="'+I(item.img)+'" alt="'+esc(item.name)+'" style="'+imgCss+'">' : '')
   +'</div>'
   +'<div class="pd-head">'
   +'<span class="kicker">'+esc(cat.name)+'</span>'
   +'<h1>'+esc(item.name)+'</h1>'
   + (spec && spec.usage ? '<p class="pd-usage">'+esc(spec.usage)+'.</p>' : '')
   + approvals
   + facts()
   +'<div class="pd-cta">'
   +'<a class="btn btn-primary"'+QUOTE_ATTRS+' style="padding:12px 22px;font-size:15px">'+esc(BASE[t()].cta.quote)+'</a>'
   +'<a class="btn btn-secondary" href="#/solutions/'+hit.catIdx+'" style="padding:12px 22px;font-size:15px">'+esc(cat.name)+'</a>'
   +'</div></div></section>'
   + afxOverview(slug)
   +'<section class="wrap reveal" style="padding-block:26px 0">'
   + list(L.features, spec && spec.features, true)
   + list(L.compliance, spec && spec.compliance, true)
   + sizes
   + applyBlock()
   + list(L.notes, spec && spec.notes, false)
   + (spec ? '<p class="pd-ref">'+esc(L.catRef)+' '+spec.page+'</p>' : '')
   +'</section>'
   +'<section class="wrap reveal" style="padding-block:30px 10px"><div class="card elev-md" style="border-radius:var(--radius-lg);padding:40px;text-align:center;align-items:center;background:radial-gradient(600px 260px at 50% -20%,color-mix(in srgb,var(--color-accent) 16%,transparent),transparent 70%),var(--color-surface)">'
   +'<h2 style="font-size:clamp(22px,2.4vw,30px);letter-spacing:-.02em;margin:0 0 10px;max-width:26ch">'+esc(L.cta)+'</h2>'
   +'<p style="font-size:15px;color:var(--color-neutral-300);max-width:52ch;margin:0 0 22px">'+esc(L.ctaSub)+'</p>'
   +'<a class="btn btn-primary"'+QUOTE_ATTRS+' style="padding:12px 24px;font-size:15px">'+esc(BASE[t()].cta.quote)+'</a>'
   +'</div></section>'
   + relHtml
   + renderFooter()+'</div>';
}

function renderSolutions(){
  var c = SOLUTIONS[t()];
  var kicker = 'Solutions';
  var sel = state.solCat;
  var tabsHtml = '<button type="button" class="af-tab '+(sel==='all'?'af-tab-active':'')+'" data-action="sol-tab" data-cat="all">'+esc(c.allLabel)+'</button>'
    + c.cats.map(function(cat,i){ return '<button type="button" class="af-tab '+(sel===i?'af-tab-active':'')+'" data-action="sol-tab" data-cat="'+i+'">'+esc(cat.name)+'</button>'; }).join('');

  function subCard(s){
    var photo = s.fit === 'cover';
    var tile  = photo ? 'var(--color-accent-900)' : (s.bg || 'radial-gradient(circle at 50% 40%,#eef1f5,#c9d0d8)');
    var imgHtml = s.img ? '<img src="'+I(s.img)+'" alt="'+esc(s.name)+'" loading="lazy" style="'+(photo ? 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover' : 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain')+'">'
      : '<div style="position:absolute;inset:18px;display:grid;place-items:center;color:var(--color-neutral-600);font-size:12px;text-align:center">'+esc(s.name)+'</div>';
    return '<a class="card af-prod elev-sm" href="'+productHref(s.img)+'" style="padding:0;overflow:hidden;border-radius:var(--radius-lg);text-decoration:none">'
      +'<div style="position:relative;aspect-ratio:1/1;background:'+tile+'">'+imgHtml+'</div>'
      +'<div style="padding:16px 16px 18px"><h3 style="font-size:14px;line-height:1.25;margin:0;text-transform:uppercase;letter-spacing:.04em;color:var(--color-accent)">'+esc(s.name)+'</h3></div></a>';
  }

  var bodyHtml, headTitle, headDesc;
  var P = afxPage(), headHtml = '';
  if(sel==='all'){
    headTitle = c.allTitle; headDesc = c.allDesc;
    if(P.type === 'collections' && t() === 'en'){ headTitle = P.title || headTitle; headDesc = P.desc || headDesc; }
    if(t() === 'en') headHtml = '<p style="font-size:17px;line-height:1.6;color:var(--color-neutral-300);max-width:64ch;margin:18px 0 0">'+esc(headDesc)+'</p>'
      +'<p class="afx-also">Browse by type: <a href="/collections/pipe-hangers">Pipe hangers &amp; clamps</a> \u00b7 <a href="/collections/electromechanical-supports">All electromechanical supports</a></p>';
    bodyHtml = c.cats.map(function(cat){
      return '<div style="margin-bottom:52px"><div style="display:flex;align-items:center;gap:14px;margin-bottom:22px;padding-bottom:16px;border-bottom:1px solid var(--color-divider)">'
        +(cat.cover?'<img src="'+I(cat.cover)+'" alt="" loading="lazy" style="width:64px;height:44px;flex:none;object-fit:cover;border-radius:var(--radius-sm);border:1px solid var(--color-divider)">':'')
        +'<h2 style="font-size:19px;font-weight:600;letter-spacing:-.01em;margin:0">'+esc(cat.name)+'</h2></div>'
        +'<div class="grid-4">'+cat.sub.map(subCard).join('')+'</div></div>';
    }).join('');
  } else {
    var cat = c.cats[sel];
    headTitle = cat.name; headDesc = cat.desc;
    if(P.type === 'collection' && P.handle === CAT_HANDLES[sel] && t() === 'en'){
      headTitle = P.title || headTitle;
      if(P.description) headHtml = '<div class="afx-colldesc">'+P.description+'</div>';
    }
    bodyHtml = '<div class="grid-4">'+cat.sub.map(subCard).join('')+'</div>';
  }

  return ''
   +'<div class="page-bg">'+renderHeader('products')
   +'<section class="wrap reveal" style="padding-block:72px 0 0"><span class="kicker">'+esc(kicker)+'</span>'
   +'<h1 style="font-family:var(--font-heading);font-weight:600;font-size:clamp(34px,4.4vw,56px);line-height:1.05;letter-spacing:-.02em;margin:18px 0 0;max-width:20ch">'+esc(headTitle)+'</h1>'
   +(headHtml || '<p style="font-size:17px;line-height:1.6;color:var(--color-neutral-300);max-width:64ch;margin:18px 0 0">'+esc(headDesc)+'</p>')+'</section>'
   +'<div style="position:sticky;top:var(--hdr,71px);z-index:30;background:color-mix(in srgb,var(--color-bg) 88%,transparent);backdrop-filter:blur(10px);border-bottom:1px solid var(--color-divider);margin-top:36px">'
   +'<div class="wrap af-scrollx" style="padding-block:14px;display:flex;gap:10px">'+tabsHtml+'</div></div>'
   +'<section class="wrap reveal" style="padding-block:44px 60px">'+bodyHtml+'</section>'
   +'<section class="wrap reveal" style="padding-block:0 84px"><div class="card elev-md" style="border-radius:var(--radius-lg);padding:44px;text-align:center;align-items:center;background:radial-gradient(600px 260px at 50% -20%,color-mix(in srgb,var(--color-accent) 16%,transparent),transparent 70%),var(--color-surface)">'
   +'<h2 style="font-size:clamp(24px,2.6vw,32px);letter-spacing:-.02em;margin:0 0 10px;max-width:24ch">'+esc(c.ctaBand.title)+'</h2>'
   +'<p style="font-size:15px;color:var(--color-neutral-300);max-width:48ch;margin:0 0 24px">'+esc(c.ctaBand.sub)+'</p>'
   +'<a class="btn btn-primary"'+QUOTE_ATTRS+' style="padding:12px 24px;font-size:15px">'+esc(BASE[t()].cta.quote)+'</a></div></section>'
   +renderFooter()+'</div>';
}

function renderProjects(){
  var projs = PROJECTS[t()];
  var sel = state.projCat;
  var labels = CATLABEL[t()];
  var tabsHtml = '<button type="button" class="af-tab '+(sel==='all'?'af-tab-active':'')+'" data-action="proj-tab" data-cat="all">'+esc(labels.all)+'</button>'
    + CATLIST.filter(function(k){ return projs.some(function(p){ return (p.catKey||p.cat)===k; }); })
      .map(function(k){ return '<button type="button" class="af-tab '+(sel===k?'af-tab-active':'')+'" data-action="proj-tab" data-cat="'+k+'">'+esc(labels[k])+'</button>'; }).join('');
  var filtered = sel==='all' ? projs : projs.filter(function(p){ return (p.catKey||p.cat)===sel; });
  var kicker = 'Projects';
  var title = 'On Egypt’s landmark builds.';
  var sub = 'AFROFIX supports carry the mechanical, fire and plumbing services behind hospitals, banks, power plants, transit lines, towers and destinations across Egypt.';
  var cardsHtml = filtered.map(function(p){
    var href = p.detail ? '#/projects/central-bank' : '#/projects';
    return '<a class="af-proj" href="'+href+'" style="aspect-ratio:4/3;border-radius:var(--radius-md)">'
      +'<div class="af-proj-img" style="background-image:url('+I(p.img)+')"></div>'
      +'<div style="position:absolute;inset:0;background:linear-gradient(to top,color-mix(in srgb,var(--color-bg) 92%,transparent) 8%,transparent 58%);pointer-events:none"></div>'
      +'<div style="position:absolute;inset-inline:0;bottom:0;padding:18px;pointer-events:none">'
      +'<div style="font-size:16px;font-weight:600;line-height:1.25;color:var(--color-text)">'+esc(p.name)+'</div>'
      +'<div style="font-size:12px;color:var(--color-neutral-300);margin-top:4px">'+esc(p.place)+' · '+esc(p.cat)+'</div></div></a>';
  }).join('');
  var ctaTitle = 'Building something at this scale?';
  var ctaSub = 'Tell us about your project — our engineering team will support the specification from day one.';

  return ''
   +'<div class="page-bg">'+renderHeader('projects')
   +'<section class="wrap reveal" style="padding-block:80px 8px"><span class="kicker">'+esc(kicker)+'</span>'
   +'<h1 style="font-family:var(--font-heading);font-weight:600;font-size:clamp(36px,4.6vw,58px);line-height:1.05;letter-spacing:-.02em;margin:20px 0 0;max-width:18ch">'+esc(title)+'</h1>'
   +'<p style="font-size:18px;line-height:1.6;color:var(--color-neutral-300);max-width:62ch;margin:22px 0 0">'+esc(sub)+'</p></section>'
   +'<div style="position:sticky;top:var(--hdr,71px);z-index:30;background:color-mix(in srgb,var(--color-bg) 88%,transparent);backdrop-filter:blur(10px);border-bottom:1px solid var(--color-divider);margin-top:36px">'
   +'<div class="wrap af-scrollx" style="padding-block:14px;display:flex;gap:10px">'+tabsHtml+'</div></div>'
   +'<section class="wrap reveal" style="padding-block:44px 72px"><div class="grid-3">'+cardsHtml+'</div></section>'
   + projectRefs(filtered)
   +'<section class="wrap reveal" style="padding-block:0 84px"><div class="card elev-md" style="border-radius:var(--radius-lg);padding:44px;text-align:center;align-items:center;background:radial-gradient(600px 260px at 50% -20%,color-mix(in srgb,var(--color-accent) 16%,transparent),transparent 70%),var(--color-surface)">'
   +'<h2 style="font-size:clamp(24px,2.6vw,32px);letter-spacing:-.02em;margin:0 0 10px;max-width:26ch">'+esc(ctaTitle)+'</h2>'
   +'<p style="font-size:15px;color:var(--color-neutral-300);max-width:48ch;margin:0 0 24px">'+esc(ctaSub)+'</p>'
   +'<a class="btn btn-primary"'+QUOTE_ATTRS+' style="padding:12px 24px;font-size:15px">'+esc(BASE[t()].cta.quote)+'</a></div></section>'
   +renderFooter()+'</div>';
}

function renderProjectDetail(){
  var d = CENTRALBANK[t()];
  return ''
   +'<div class="page-bg">'+renderHeader('projects')
   +'<section class="wrap reveal" style="padding-block:40px 0"><a class="af-link" href="#/projects" style="display:inline-flex;align-items:center;gap:6px;font-weight:600">← '+esc(d.back)+'</a></section>'
   +'<section class="wrap reveal" style="padding-block:20px 0"><div style="position:relative;aspect-ratio:16/9;border-radius:var(--radius-lg);overflow:hidden;border:1px solid var(--color-divider)"><img src="'+I('central-bank.jpg')+'" style="width:100%;height:100%;object-fit:cover"></div></section>'
   +'<section class="wrap reveal" style="padding-block:40px 24px;display:grid;grid-template-columns:7fr 5fr;gap:56px" data-cb-grid>'
   +'<div><span class="kicker">'+esc(d.kicker)+'</span><h1 style="font-family:var(--font-heading);font-weight:600;font-size:clamp(30px,3.6vw,46px);line-height:1.1;letter-spacing:-.02em;margin:18px 0 28px;max-width:18ch">'+esc(d.title)+'</h1>'
   +'<p style="font-size:16px;line-height:1.7;color:var(--color-neutral-300);margin:0 0 18px;max-width:64ch">'+esc(d.p1)+'</p>'
   +'<p style="font-size:16px;line-height:1.7;color:var(--color-neutral-300);margin:0 0 18px;max-width:64ch">'+esc(d.p2)+'</p>'
   +'<p style="font-size:13px;line-height:1.6;color:var(--color-neutral-500);margin:0;max-width:64ch;font-style:italic">'+esc(d.note)+'</p></div>'
   +'<div class="card elev-sm" style="padding:28px;border-radius:var(--radius-lg);gap:0;align-self:start">'
   +d.meta.map(function(m){ return '<div style="display:flex;justify-content:space-between;gap:16px;padding:14px 0;border-bottom:1px solid var(--color-divider)"><span style="font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:var(--color-neutral-400)">'+esc(m.label)+'</span><span style="font-size:14px;color:var(--color-text);text-align:right;max-width:56%">'+esc(m.value)+'</span></div>'; }).join('')
   +'<div style="padding-top:18px"><div style="font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:var(--color-neutral-400);margin-bottom:10px">'+esc(d.scopeLabel)+'</div>'
   +'<div style="display:flex;gap:8px;flex-wrap:wrap">'+d.scope.map(function(s){ return '<span class="tag tag-outline">'+esc(s)+'</span>'; }).join('')+'</div></div></div></section>'
   +'<section class="wrap reveal" style="padding-block:24px 84px"><div class="card elev-md" style="border-radius:var(--radius-lg);padding:44px;text-align:center;align-items:center;background:radial-gradient(600px 260px at 50% -20%,color-mix(in srgb,var(--color-accent) 16%,transparent),transparent 70%),var(--color-surface)">'
   +'<h2 style="font-size:clamp(24px,2.6vw,32px);letter-spacing:-.02em;margin:0 0 10px;max-width:26ch">'+esc(d.ctaBand.title)+'</h2>'
   +'<p style="font-size:15px;color:var(--color-neutral-300);max-width:48ch;margin:0 0 24px">'+esc(d.ctaBand.sub)+'</p>'
   +'<a class="btn btn-primary"'+QUOTE_ATTRS+' style="padding:12px 24px;font-size:15px">'+esc(BASE[t()].cta.quote)+'</a></div></section>'
   +renderFooter()+'</div>';
}

function renderCertificates(){
  var c = CERTPAGE[t()];
  var certsHtml = c.certs.map(function(cert){
    var chip = cert.img ? '<img src="'+I(cert.img)+'" style="width:100%;height:100%;object-fit:contain">' : '<span style="font-family:var(--font-heading);font-weight:700;color:var(--color-neutral-400)">'+esc(cert.code)+'</span>';
    var bg = cert.img ? '#ffffff' : 'var(--color-bg)';
    return '<div class="card elev-sm" style="padding:32px;border-radius:var(--radius-lg);gap:20px">'
      +'<div style="width:120px;height:120px;border-radius:var(--radius-md);border:1px solid var(--color-divider);display:grid;place-items:center;padding:16px;background:'+bg+'">'+chip+'</div>'
      +'<div><h2 style="font-size:22px;margin:0 0 10px">'+esc(cert.name)+'</h2><p style="font-size:14px;line-height:1.6;color:var(--color-neutral-300);margin:0">'+esc(cert.desc)+'</p></div></div>';
  }).join('');
  var docsHtml = (c.docs||[]).map(function(doc){
    return '<figure class="cert-doc" style="margin:0;display:flex;flex-direction:column;gap:12px">'
      +'<a href="'+I(doc.img)+'" target="_blank" rel="noopener" style="display:block;border-radius:var(--radius-md);overflow:hidden;border:1px solid var(--color-divider);background:#ffffff">'
      +'<img src="'+I(doc.img)+'" alt="'+esc(doc.name)+'" loading="lazy" style="width:100%;height:auto;display:block">'
      +'</a>'
      +'<figcaption style="font-size:13px;color:var(--color-neutral-300)">'+esc(doc.name)+'</figcaption></figure>';
  }).join('');
  var pointsHtml = c.quality.points.map(function(pt){
    return '<div style="display:flex;gap:14px;align-items:flex-start"><span style="flex:none;width:24px;height:24px;border-radius:50%;border:1px solid var(--color-accent);color:var(--color-accent);display:grid;place-items:center;font-size:13px;font-weight:700">✓</span><span style="font-size:14.5px;line-height:1.5;color:var(--color-text)">'+esc(pt)+'</span></div>';
  }).join('');
  return ''
   +'<div class="page-bg">'+renderHeader('')
   +'<section class="wrap reveal" style="padding-block:80px 8px"><span class="kicker">'+esc(c.head.kicker)+'</span>'
   +'<h1 style="font-family:var(--font-heading);font-weight:600;font-size:clamp(36px,4.6vw,58px);line-height:1.05;letter-spacing:-.02em;margin:20px 0 0;max-width:18ch">'+esc(c.head.title)+'</h1>'
   +'<p style="font-size:18px;line-height:1.6;color:var(--color-neutral-300);max-width:64ch;margin:22px 0 0">'+esc(c.head.sub)+'</p></section>'
   +'<section class="wrap reveal" style="padding-block:48px 24px"><div class="grid-3">'+certsHtml+'</div></section>'
   +'<section class="wrap reveal" style="padding-block:56px 8px"><div class="hr-fade" style="margin-bottom:48px"></div>'
   +'<span class="kicker">'+esc(c.docsHead.kicker)+'</span>'
   +'<div style="display:flex;align-items:flex-end;justify-content:space-between;gap:20px;flex-wrap:wrap;margin:18px 0 36px"><h2 style="font-size:clamp(28px,3vw,40px);letter-spacing:-.02em;margin:0;max-width:22ch">'+esc(c.docsHead.title)+'</h2><p style="font-size:15px;color:var(--color-neutral-300);max-width:46ch;margin:0">'+esc(c.docsHead.sub)+'</p></div>'
   +'<div class="grid-3">'+docsHtml+'</div></section>'
   +'<section class="wrap reveal" style="padding-block:32px 84px"><div class="card elev-md" style="border-radius:var(--radius-lg);padding:44px;display:grid;grid-template-columns:1fr 1fr;gap:40px;align-items:center" data-q-grid>'
   +'<div><span class="kicker">'+esc(c.quality.kicker)+'</span><h2 style="font-size:clamp(24px,2.6vw,32px);letter-spacing:-.02em;margin:16px 0 14px;max-width:22ch">'+esc(c.quality.title)+'</h2>'
   +'<p style="font-size:15px;line-height:1.7;color:var(--color-neutral-300);margin:0;max-width:56ch">'+esc(c.quality.body)+'</p></div>'
   +'<div style="display:flex;flex-direction:column;gap:14px">'+pointsHtml+'</div></div></section>'
   +renderFooter()+'</div>';
}

var ABOUT_SHOTS = [
  {img:'prod-clevis-hanger-ul-fm.jpg', bg:'#f7f7f7'},
  {img:'prod-dsm-pipe-clamp.jpg',      bg:'#f7f7f7'},
  {img:'prod-sam-strut-channel.jpg',   bg:'#ffffff'},
  {img:'prod-beam-clamp-type-a.jpg',   bg:'#f0f0f0'}
];

function renderAbout(){
  var a = ABOUT[t()];
  var statsHtml = a.stats.map(function(s){ return '<div><div style="font-family:var(--font-heading);font-weight:600;font-size:34px;line-height:1;color:var(--color-accent)">'+esc(s.num)+'</div><div style="font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:var(--color-neutral-400);margin-top:8px">'+esc(s.label)+'</div></div>'; }).join('');
  return ''
   +'<div class="page-bg">'+renderHeader('about')
   +'<section class="wrap reveal" style="padding-block:80px 8px"><span class="kicker">'+esc(a.kicker)+'</span>'
   +'<h1 style="font-family:var(--font-heading);font-weight:600;font-size:clamp(36px,4.6vw,58px);line-height:1.05;letter-spacing:-.02em;margin:20px 0 0;max-width:20ch">'+esc(a.title)+'</h1></section>'
   +'<section id="ab-profile" class="wrap reveal" style="padding-block:40px 24px;display:grid;grid-template-columns:5fr 7fr;gap:56px;align-items:center" data-about-grid>'
   +'<div class="about-collage">'
   + ABOUT_SHOTS.map(function(o){ return '<figure style="margin:0;border-radius:var(--radius-md);overflow:hidden;aspect-ratio:1/1;border:1px solid var(--color-divider);background:'+o.bg+'">'
       +'<img src="'+I(o.img)+'" alt="" loading="lazy" style="width:100%;height:100%;object-fit:'+(o.fit||'contain')+';display:block"></figure>'; }).join('')
   +'</div>'
   +'<div><p style="font-size:16px;line-height:1.7;color:var(--color-neutral-300);margin:0 0 16px;max-width:64ch">'+esc(a.p1)+'</p>'
   +'<p style="font-size:16px;line-height:1.7;color:var(--color-neutral-300);margin:0 0 28px;max-width:64ch">'+esc(a.p2)+'</p>'
   +'<div style="display:grid;grid-template-columns:repeat(2,1fr);gap:24px;margin-bottom:28px">'+statsHtml+'</div>'
   +'<div style="display:flex;gap:14px;flex-wrap:wrap">'
   +'<a class="btn btn-primary" href="https://cdn.shopify.com/s/files/1/0732/6220/2989/files/AFROFIX-Brochure-2026.pdf?v=1790212259" target="_blank" rel="noopener" style="padding:12px 22px;font-size:15px">'+esc(a.profile)+'</a>'
   +'<a class="btn btn-secondary" href="#/projects" style="padding:12px 22px;font-size:15px">'+esc(a.seeWork)+'</a></div></div></section>'
   +'<section id="ab-mission" class="wrap reveal" style="padding-block:64px 8px"><div class="hr-fade" style="margin-bottom:52px"></div>'
   +'<span class="kicker">'+esc(a.mvKicker)+'</span>'
   +'<h2 style="font-size:clamp(28px,3vw,40px);letter-spacing:-.02em;margin:18px 0 40px;max-width:22ch">'+esc(a.mvTitle)+'</h2>'
   +'<div class="about-mv">'
   +'<div class="card elev-sm" style="padding:32px;border-radius:var(--radius-lg)">'
   +'<h3 style="font-size:13px;letter-spacing:.14em;text-transform:uppercase;color:var(--color-accent);margin:0 0 18px">'+esc(a.missionHead)+'</h3>'
   + a.mission.map(function(p){ return '<p style="font-size:15.5px;line-height:1.7;color:var(--color-neutral-300);margin:0 0 14px">'+esc(p)+'</p>'; }).join('')
   +'</div>'
   +'<div class="card elev-sm" style="padding:32px;border-radius:var(--radius-lg)">'
   +'<h3 style="font-size:13px;letter-spacing:.14em;text-transform:uppercase;color:var(--color-accent);margin:0 0 18px">'+esc(a.visionHead)+'</h3>'
   +'<p style="font-size:15.5px;line-height:1.7;color:var(--color-neutral-300);margin:0 0 16px">'+esc(a.visionLead)+'</p>'
   +'<ul class="about-vision">'+a.vision.map(function(v){ return '<li>'+esc(v)+'</li>'; }).join('')+'</ul>'
   +'</div></div></section>'

   +'<section id="ab-leadership" class="wrap reveal" style="padding-block:64px 8px"><div class="hr-fade" style="margin-bottom:52px"></div>'
   +'<span class="kicker">'+esc(a.chairKicker)+'</span>'
   +'<div class="about-chair">'
   +'<figure style="margin:0;border-radius:var(--radius-lg);overflow:hidden;border:1px solid var(--color-divider);background:var(--color-neutral-800)">'
   +'<img src="'+I('mourad.jpg')+'" alt="'+esc(a.chairName)+'" loading="lazy" style="width:100%;height:auto;object-fit:contain;display:block"></figure>'
   +'<div><h2 style="font-size:clamp(24px,2.6vw,32px);letter-spacing:-.02em;margin:0 0 4px">'+esc(a.chairName)+'</h2>'
   +'<div style="font-size:13px;letter-spacing:.12em;text-transform:uppercase;color:var(--color-accent);margin-bottom:22px">'+esc(a.chairRole)+'</div>'
   + a.chair.map(function(p){ return '<p style="font-size:15.5px;line-height:1.7;color:var(--color-neutral-300);margin:0 0 15px;max-width:66ch">'+esc(p)+'</p>'; }).join('')
   +'</div></div></section>'

   +'<section class="wrap reveal" style="padding-block:32px 84px"><div class="card elev-md" style="border-radius:var(--radius-lg);padding:44px;text-align:center;align-items:center;background:radial-gradient(600px 260px at 50% -20%,color-mix(in srgb,var(--color-accent) 16%,transparent),transparent 70%),var(--color-surface)">'
   +'<h2 style="font-size:clamp(24px,2.6vw,32px);letter-spacing:-.02em;margin:0 0 10px;max-width:26ch">'+esc(a.ctaTitle)+'</h2>'
   +'<p style="font-size:15px;color:var(--color-neutral-300);max-width:48ch;margin:0 0 24px">'+esc(a.ctaSub)+'</p>'
   +'<div style="display:flex;gap:14px;flex-wrap:wrap;justify-content:center">'
   +'<a class="btn btn-primary" href="#/contractors" style="padding:12px 24px;font-size:15px">'+esc(a.ctaContractors)+'</a>'
   +'<a class="btn btn-secondary" href="#/consultants" style="padding:12px 24px;font-size:15px">'+esc(a.ctaConsultants)+'</a></div></div></section>'
   +renderFooter()+'</div>';
}

function renderContractors(){
  var c = CONTRACTORS_PAGE[t()];
  var gridHtml = CONTRACTORS.map(firmCell).join('');
  return ''
   +'<div class="page-bg">'+renderHeader('contractors')
   +'<section class="wrap reveal" style="padding-block:80px 8px"><span class="kicker">'+esc(c.kicker)+'</span>'
   +'<h1 style="font-family:var(--font-heading);font-weight:600;font-size:clamp(36px,4.6vw,58px);line-height:1.05;letter-spacing:-.02em;margin:20px 0 16px;max-width:20ch">'+esc(c.title)+'</h1>'
   +'<p style="font-size:17px;line-height:1.6;color:var(--color-neutral-300);max-width:66ch;margin:0">'+esc(c.sub)+'</p></section>'
   +'<section class="wrap reveal" style="padding-block:48px 24px"><div class="firmrow">'+gridHtml+'</div></section>'
   + partnerText('contractors')
   +'<section class="wrap reveal" style="padding-block:40px 84px"><div class="card elev-md" style="border-radius:var(--radius-lg);padding:44px;text-align:center;align-items:center;background:radial-gradient(600px 260px at 50% -20%,color-mix(in srgb,var(--color-accent) 16%,transparent),transparent 70%),var(--color-surface)">'
   +'<h2 style="font-size:clamp(24px,2.6vw,32px);letter-spacing:-.02em;margin:0 0 10px;max-width:26ch">'+esc(c.ctaBand.title)+'</h2>'
   +'<p style="font-size:15px;color:var(--color-neutral-300);max-width:48ch;margin:0 0 24px">'+esc(c.ctaBand.sub)+'</p>'
   +'<a class="btn btn-primary"'+QUOTE_ATTRS+' style="padding:12px 24px;font-size:15px">'+esc(BASE[t()].cta.quote)+'</a></div></section>'
   +renderFooter()+'</div>';
}

function renderConsultants(){
  var c = CONSULTANTS_PAGE[t()];
  var gridHtml = CONSULTANTS.map(firmCell).join('');
  return ''
   +'<div class="page-bg">'+renderHeader('consultants')
   +'<section class="wrap reveal" style="padding-block:80px 8px"><span class="kicker">'+esc(c.kicker)+'</span>'
   +'<h1 style="font-family:var(--font-heading);font-weight:600;font-size:clamp(36px,4.6vw,58px);line-height:1.05;letter-spacing:-.02em;margin:20px 0 16px;max-width:20ch">'+esc(c.title)+'</h1>'
   +'<p style="font-size:17px;line-height:1.6;color:var(--color-neutral-300);max-width:66ch;margin:0">'+esc(c.sub)+'</p></section>'
   +'<section class="wrap reveal" style="padding-block:48px 24px"><div class="firmrow">'+gridHtml+'</div></section>'
   + partnerText('consultants')
   +'<section class="wrap reveal" style="padding-block:40px 84px"><div class="card elev-md" style="border-radius:var(--radius-lg);padding:44px;text-align:center;align-items:center;background:radial-gradient(600px 260px at 50% -20%,color-mix(in srgb,var(--color-accent) 16%,transparent),transparent 70%),var(--color-surface)">'
   +'<h2 style="font-size:clamp(24px,2.6vw,32px);letter-spacing:-.02em;margin:0 0 10px;max-width:26ch">'+esc(c.ctaBand.title)+'</h2>'
   +'<p style="font-size:15px;color:var(--color-neutral-300);max-width:48ch;margin:0 0 24px">'+esc(c.ctaBand.sub)+'</p>'
   +'<a class="btn btn-primary"'+QUOTE_ATTRS+' style="padding:12px 24px;font-size:15px">'+esc(BASE[t()].cta.quote)+'</a></div></section>'
   +renderFooter()+'</div>';
}

function renderContact(){
  var c = CONTACT[t()];
  var bodyHtml;
  if(state.submitted){
    bodyHtml = '<div style="display:flex;flex-direction:column;gap:10px;padding:24px 0;text-align:center"><div style="font-family:var(--font-heading);font-size:22px;color:var(--color-accent)">'+esc(c.thanksTitle)+'</div><p style="font-size:14px;color:var(--color-neutral-300);margin:0">'+esc(c.thanksBody)+'</p></div>';
  } else {
    // Quotation requests are taken on the AFROFIX ERPNext web form so they land
    // in the ERP rather than being lost in a page-local form.
    bodyHtml = '<div><h2 style="font-size:20px;margin:0 0 4px">'+esc(c.formTitle)+'</h2>'
     +'<p style="font-size:13px;color:var(--color-neutral-300);margin:0 0 20px">'+esc(c.formSub)+'</p>'
     +'<div style="display:flex;flex-direction:column;gap:16px">'
     +'<div style="display:flex;flex-direction:column;gap:11px">'
     + c.readyList.map(function(t){
         return '<div style="display:flex;align-items:flex-start;gap:10px">'
           +'<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" style="flex:none;margin-top:2px"><path d="M20 6 9 17l-5-5"/></svg>'
           +'<span style="font-size:14px;line-height:1.5;color:var(--color-neutral-300)">'+esc(t)+'</span></div>';
       }).join('')
     +'</div>'
     +'<a class="btn btn-primary btn-block"'+QUOTE_ATTRS+' style="min-height:46px;font-size:15px;gap:9px">'
     + esc(BASE[t()].cta.quote)
     +'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg></a>'
     +'<p style="font-size:12px;color:var(--color-neutral-400);margin:0;text-align:center">'+esc(c.formNote)+'</p>'
     +'</div></div>';
  }
  return ''
   +'<div class="page-bg">'+renderHeader('contact')
   +'<section class="wrap reveal" style="padding-block:80px 60px"><div style="display:grid;grid-template-columns:1fr 1fr;gap:56px" data-contact-grid>'
   +'<div><span class="kicker">'+esc(c.kicker)+'</span>'
   +'<h1 style="font-family:var(--font-heading);font-weight:600;font-size:clamp(34px,4.2vw,54px);line-height:1.05;letter-spacing:-.02em;margin:20px 0 16px;max-width:16ch">'+esc(c.title)+'</h1>'
   +'<p style="font-size:16px;line-height:1.65;color:var(--color-neutral-300);max-width:48ch;margin:0 0 34px">'+esc(c.sub)+'</p>'
   +'<div style="display:flex;flex-direction:column;gap:24px">'
   +'<div><div style="font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:var(--color-accent);margin-bottom:6px">'+esc(c.addressLabel)+'</div><a class="af-link af-map" href="'+MAPS_URL+'" target="_blank" rel="noopener" style="display:inline-flex;gap:8px;align-items:flex-start;font-size:15px;line-height:1.5;color:var(--color-text)">'
   +'<span style="margin-top:3px;color:var(--color-accent)">'+PIN_SVG+'</span>'
   +'<span>Plot No. 132 — 6th Industrial Zone Extension<br>6th of October City, Egypt<br><span style="color:var(--color-accent);font-size:13px">'+('View on Google Maps')+'</span></span></a></div>'
   +'<div><div style="font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:var(--color-accent);margin-bottom:6px">'+esc(c.phoneLabel)+'</div><div dir="ltr" style="font-size:15px;line-height:1.6;color:var(--color-text)">(+2) 0100 1012 905<br>(+2) 0127 2522 278</div></div>'
   +'<div><div style="font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:var(--color-accent);margin-bottom:6px">'+esc(c.emailLabel)+'</div><div style="display:flex;flex-direction:column;gap:4px">'+'<a class="af-link" href="mailto:info@afrofix.com" style="font-size:15px;color:var(--color-text)">info@afrofix.com</a>'+'<a class="af-link" href="mailto:sales@afrofix.com" style="font-size:15px;color:var(--color-text)">sales@afrofix.com</a>'+'</div></div>'
   +'</div></div>'
   +'<div class="card elev-md" style="padding:30px;border-radius:var(--radius-lg);gap:16px">'+bodyHtml+'</div>'
   +'</div></section>'
   +renderFooter()+'</div>';
}

var ABOUT_SECTIONS = { mission:'ab-mission', leadership:'ab-leadership', profile:'ab-profile' };

var ROUTES = {
  '/': renderHome, '': renderHome,
  '/solutions': renderSolutions,
  '/product': renderProduct,
  '/projects': renderProjects,
  '/projects/central-bank': renderProjectDetail,
  '/certificates': renderCertificates,
  '/about': renderAbout,
  '/contractors': renderContractors,
  '/consultants': renderConsultants,
  '/contact': renderContact,
  '/collection': renderCollection,
  '/cms': renderCms,
  '/blog': renderBlogList,
};


/* Draw the phone serpentine route: measure each moment's node/card and thread
   a smooth curve through the gap between them, with a dot at every stop. */
function layoutMopRoute(){
  var tl = document.querySelector('.mop-tl');
  var svg = tl && tl.querySelector('.mop-route-m');
  if(!tl || !svg) return;
  if(window.innerWidth > 840){ svg.removeAttribute('viewBox'); return; }
  var ms = tl.querySelectorAll('.mop-m');
  if(!ms.length) return;
  var tr = tl.getBoundingClientRect();
  var W = Math.round(tr.width), H = Math.round(tr.height);
  if(!W || !H) return;
  var rows = [];
  for(var i=0;i<ms.length;i++){
    var node = ms[i].querySelector('.mop-node');
    var card = ms[i].querySelector('.mop-card');
    if(!node || !card) continue;
    var nb = node.getBoundingClientRect(), cb = card.getBoundingClientRect(), mb = ms[i].getBoundingClientRect();
    // the clear channel between the two columns
    var x = (nb.left < cb.left) ? ((nb.right + cb.left)/2) : ((cb.right + nb.left)/2);
    rows.push({
      x    : Math.round(x - tr.left),
      top  : Math.round(mb.top - tr.top),
      bot  : Math.round(mb.bottom - tr.top),
      cTop : Math.round(cb.top - tr.top),
      cBot : Math.round(cb.bottom - tr.top),
      cy   : Math.round(nb.top + nb.height/2 - tr.top)
    });
  }
  if(rows.length < 2) return;
  // run straight down the channel through each row, then bend across in the
  // empty space between rows so the curve never disappears behind a card
  // start a little above the first node and stop just past the last one
  var d = 'M '+rows[0].x+' '+Math.max(0, rows[0].cy - 46);
  for(var j=0;j<rows.length;j++){
    var lastRow = (j === rows.length-1);
    var endY = lastRow ? Math.min(H, rows[j].cy + 46) : rows[j].cBot;
    d += ' L '+rows[j].x+' '+endY;
    if(!lastRow){
      var a = rows[j], b = rows[j+1];
      // ease across using the full clear band so the S reads long and lazy
      var span = Math.max(1, b.cTop - a.cBot);
      var c1 = a.cBot + span*0.5, c2 = b.cTop - span*0.5;
      d += ' C '+a.x+' '+c1+', '+b.x+' '+c2+', '+b.x+' '+b.cTop;
    }
  }
  var pts = rows.map(function(r){ return [r.x, r.cy]; });
  svg.setAttribute('viewBox','0 0 '+W+' '+H);
  svg.setAttribute('width',W); svg.setAttribute('height',H);
  var g = svg.querySelector('.rm-guide'), l = svg.querySelector('.rm-live');
  if(g) g.setAttribute('d', d);
  if(l) l.setAttribute('d', d);
  var dots = svg.querySelector('.rm-dots');
  if(dots){
    var out = '';
    for(var k=0;k<pts.length;k++){
      out += '<circle cx="'+pts[k][0]+'" cy="'+pts[k][1]+'" r="6"></circle>';
    }
    dots.innerHTML = out;
  }
}
var mopRouteTimer;
function scheduleMopRoute(){
  clearTimeout(mopRouteTimer);
  mopRouteTimer = setTimeout(layoutMopRoute, 60);
}
window.addEventListener('resize', scheduleMopRoute);
window.addEventListener('load', scheduleMopRoute);

/* Real Shopify URLs <-> app views. The site used to live entirely on #/ hash
   routes, which Google cannot index; every view now has a real address and the
   hash is only used for in-view states (a project category, an About section). */
var CAT_HANDLES = ['fire-fighting','hvac','plumbing','sam-strut','steel-structure-support','fixation'];
var PAGE_ROUTES = {about:'/about', projects:'/projects', certificates:'/certificates', contact:'/contact',
                   contractors:'/contractors', consultants:'/consultants'};
var REAL_BASE = {'/about':'/pages/about','/projects':'/pages/projects','/certificates':'/pages/certificates',
                 '/contact':'/pages/contact','/contractors':'/pages/contractors','/consultants':'/pages/consultants'};

function pathFromLocation(){
  var P = window.AFX_PAGE || {};
  if(P.type === 'cms') return '/cms';
  if(P.type === 'blog') return '/blog';
  var p = location.pathname.replace(/\/+$/, '') || '/';
  var m;
  if(p === '/') return '/';
  if(p === '/collections') return '/solutions';
  if((m = /^\/collections\/([a-z0-9\-]+)$/.exec(p))){
    var i = CAT_HANDLES.indexOf(m[1]);
    return i >= 0 ? '/solutions/'+i : '/collection/'+m[1];
  }
  if((m = /^\/products\/([a-z0-9\-]+)$/.exec(p))) return '/product/'+m[1];
  if((m = /^\/pages\/([a-z0-9\-]+)$/.exec(p)) && PAGE_ROUTES[m[1]]) return PAGE_ROUTES[m[1]];
  return '/';
}

function currentPath(){
  var h = (location.hash || '').replace(/^#/, '');
  if(h && h !== '/' && h.charAt(0) === '/') return h;
  return pathFromLocation();
}

/* '#/solutions/2' -> '/collections/plumbing', '#/about/leadership' -> '/pages/about#/about/leadership' */
function realUrl(href){
  if(!href || href.charAt(0) !== '#') return href;
  var p = href.replace(/^#/, '') || '/';
  var m;
  if(p === '/') return '/';
  if(p === '/solutions') return '/collections';
  if((m = /^\/solutions\/(\d+)$/.exec(p))) return CAT_HANDLES[+m[1]] ? '/collections/'+CAT_HANDLES[+m[1]] : '/collections';
  if((m = /^\/product\/([a-z0-9\-]+)$/.exec(p))) return '/products/'+m[1];
  if(REAL_BASE[p]) return REAL_BASE[p];
  if((m = /^\/(about|projects)\/(.+)$/.exec(p))) return REAL_BASE['/'+m[1]]+'#'+p;
  return href;
}
function afxLinks(html){
  return html.replace(/href="(#\/[^"]*)"/g, function(_, h){ return 'href="'+realUrl(h)+'"'; });
}

var REDUCE_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var countedOnce = {};

function setupReveal(){
  if(!('IntersectionObserver' in window)){
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){ entry.target.classList.add('in'); io.unobserve(entry.target); }
    });
  }, {threshold:0.12});
  document.querySelectorAll('.reveal:not(.in)').forEach(function(el){ io.observe(el); });
}

function setupCounters(){
  if(!('IntersectionObserver' in window)){
    document.querySelectorAll('[data-count]').forEach(runCounter);
    return;
  }
  var io2 = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){ runCounter(entry.target); io2.unobserve(entry.target); }
    });
  }, {threshold:0.4});
  document.querySelectorAll('[data-count]').forEach(function(el){
    var key = el.getAttribute('data-key');
    if(countedOnce[key]) { el.textContent = el.getAttribute('data-final'); return; }
    io2.observe(el);
  });
}
function runCounter(el){
  var key = el.getAttribute('data-key');
  countedOnce[key] = true;
  var target = parseInt(el.getAttribute('data-count'), 10);
  var suffix = el.getAttribute('data-suffix') || '';
  var prefix = el.getAttribute('data-prefix') || '';
  if(REDUCE_MOTION || !target){ el.textContent = el.getAttribute('data-final'); return; }
  var start = null, dur = 1100;
  function step(ts){
    if(!start) start = ts;
    var p = Math.min(1, (ts-start)/dur);
    var eased = 1 - Math.pow(1-p, 3);
    el.textContent = prefix + Math.round(eased*target) + suffix;
    if(p<1) requestAnimationFrame(step); else el.textContent = el.getAttribute('data-final');
  }
  requestAnimationFrame(step);
}

var heroTimer = null;
function setupHeroSlider(){
  if(heroTimer){ clearInterval(heroTimer); heroTimer = null; }
  var root = document.querySelector('[data-hero]');
  if(!root) return;
  var slides = root.querySelectorAll('[data-hero-slide]');
  var dots = root.querySelectorAll('[data-hero-dot]');
  var n = slides.length;
  if(!n) return;
  var idx = 0, dragged = false;

  function show(i){
    idx = (i % n + n) % n;
    for(var k=0;k<n;k++){
      slides[k].classList.toggle('on', k===idx);
      slides[k].setAttribute('aria-hidden', k===idx ? 'false' : 'true');
      if(dots[k]){
        dots[k].classList.toggle('on', k===idx);
        dots[k].setAttribute('aria-current', k===idx ? 'true' : 'false');
      }
    }
  }
  function step(d){ show(idx + d); }
  function stop(){ if(heroTimer){ clearInterval(heroTimer); heroTimer = null; } }
  function restart(){
    stop();
    if(REDUCE_MOTION || n < 2) return;
    heroTimer = setInterval(function(){ step(1); }, 6000);
  }

  root.addEventListener('click', function(e){
    if(dragged){ dragged = false; e.preventDefault(); return; }
    var nav = e.target.closest('[data-hero-nav]');
    if(nav){ e.preventDefault(); step(Number(nav.getAttribute('data-hero-nav'))); restart(); return; }
    var dot = e.target.closest('[data-hero-dot]');
    if(dot){ e.preventDefault(); show(Number(dot.getAttribute('data-hero-dot'))); restart(); }
  });
  root.addEventListener('keydown', function(e){
    if(e.key==='ArrowRight'){ step(1); restart(); }
    else if(e.key==='ArrowLeft'){ step(-1); restart(); }
  });
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', restart);
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', restart);

  var x0 = null;
  root.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; dragged = false; }, {passive:true});
  root.addEventListener('touchend', function(e){
    if(x0===null) return;
    var dx = e.changedTouches[0].clientX - x0;
    x0 = null;
    if(Math.abs(dx) > 40){ dragged = true; step(dx > 0 ? -1 : 1); restart(); }
  }, {passive:true});

  show(0);
  restart();
}

function afterRender(){
  requestAnimationFrame(function(){
    document.querySelectorAll('[data-fade]').forEach(function(el){ el.classList.add('in'); });
  });
  setupReveal();
  setupCounters();
  setupHeroSlider();
}

function render(){
  document.documentElement.lang = 'en';
  document.documentElement.dir = 'ltr';
  var path = currentPath();
  var m = /^\/solutions\/(\d+)$/.exec(path);
  if(m){ state.solCat = Number(m[1]); path = '/solutions'; }
  else if(path === '/solutions'){ state.solCat = 'all'; }
  // #/about/<section> renders About and then scrolls to that block
  var am = /^\/about\/([a-z]+)$/.exec(path);
  state.aboutJump = '';
  if(am){
    state.aboutJump = ABOUT_SECTIONS[am[1]] || '';
    path = '/about';
  }
  var jm = /^\/projects\/([A-Za-z][A-Za-z ]*)$/.exec(path);
  if(jm && CATLIST.indexOf(jm[1]) >= 0){ state.projCat = jm[1]; path = '/projects'; }
  else if(path === '/projects'){ state.projCat = 'all'; }
  var pm = /^\/product\/([a-z0-9\-]+)$/.exec(path);
  if(pm){ state.product = pm[1]; path = '/product'; }
  var cm = /^\/collection\/([a-z0-9\-]+)$/.exec(path);
  if(cm){ state.coll = cm[1]; path = '/collection'; }
  var fn = ROUTES[path] || renderHome;
  megaHide();
  var appEl = document.getElementById('app');
  appEl.innerHTML = afxLinks(fn());
  appEl.classList.remove('afx-ssr');
  if(state.aboutJump){
    var jump = state.aboutJump;
    // after layout, so the sticky header offset is measured against real boxes
    setTimeout(function(){
      var el = document.getElementById(jump);
      if(!el) return;
      var hdr = document.querySelector('header.site');
      var off = (hdr ? hdr.getBoundingClientRect().height : 0) + 14;
      // Deliberately an instant jump. transitionRender scrolls to the top
      // right after render, so a smooth scroll starts from 0 and animates
      // through the whole page - and it silently does nothing at all where the
      // browser has smooth scrolling disabled.
      window.scrollTo(0, Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - off));
    }, 220);
  }
  scheduleMopRoute();
  afterRender();
}

/* Smooth cross-fade between states instead of an instant snap — used for
   every tab/filter/nav change so switching feels like one continuous motion. */
function transitionRender(mutator, opts){
  opts = opts || {};
  if(REDUCE_MOTION){ mutator(); render(); if(opts.top) window.scrollTo(0,0); return; }
  var app = document.getElementById('app');
  app.style.transition = 'opacity .18s ease, transform .22s ease';
  app.style.opacity = '0';
  app.style.transform = 'translateY(8px)';
  setTimeout(function(){
    mutator();
    render();
    if(opts.top) window.scrollTo(0,0);
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        app.style.opacity = '1';
        app.style.transform = 'none';
      });
    });
  }, 160);
}

document.addEventListener('click', function(e){
  var btn = e.target.closest && e.target.closest('[data-action]');
  if(!btn) return;
  var action = btn.getAttribute('data-action');
  if(action==='sol-tab'){ var solCat=btn.getAttribute('data-cat');
    location.href = realUrl((solCat==='all') ? '#/solutions' : '#/solutions/'+solCat); }
  else if(action==='proj-tab'){ var projCat=btn.getAttribute('data-cat');
    location.hash = (projCat==='all') ? '#/projects' : '#/projects/'+projCat; }
  else if(action==='home-proj-tab'){ var homeCat=btn.getAttribute('data-cat'); transitionRender(function(){ state.homeProjCat = homeCat; }); }
  else if(action==='submit-contact'){ transitionRender(function(){ state.submitted = true; }); }
  else if(action==='menu-toggle'){ state.menuOpen = !state.menuOpen; render(); }
});
document.addEventListener('input', function(e){
  if(e.target && (e.target.id==='searchInput' || e.target.id==='searchInputMobile')){
    var srcId = e.target.id;
    state.q = e.target.value; render();
    var el=document.getElementById(srcId);
    if(el){ el.focus(); var len=el.value.length; el.setSelectionRange(len,len); }
  }
});
/* The panel opens on hover in CSS; this only swaps the preview image as the
   pointer or keyboard focus moves down the list, and lets Escape dismiss it. */
function setMegaPreview(item){
  var inner = item.closest('.af-mega__inner');
  if(!inner) return;
  var sibs = inner.querySelectorAll('.af-mega__item');
  for(var i=0;i<sibs.length;i++) sibs[i].classList.remove('is-on');
  item.classList.add('is-on');

  var fig = inner.querySelector('.af-mega__preview');
  var img = fig && fig.querySelector('img');
  var cap = fig && fig.querySelector('figcaption');
  if(!img) return;
  var label = item.getAttribute('data-label') || '';
  img.style.objectFit = item.getAttribute('data-fit') || 'cover';
  img.style.objectPosition = item.getAttribute('data-pos') || '50% 50%';
  var src = I(item.getAttribute('data-img'));
  if(!src || img.getAttribute('src') === src){ if(cap) cap.textContent = label; return; }
  // decode first, so the panel never flashes a half-painted image
  fig.classList.add('is-swap');
  var next = new Image();
  next.onload = next.onerror = function(){
    img.src = src;
    if(cap) cap.textContent = label;
    fig.classList.remove('is-swap');
  };
  next.src = src;
}
/* Opening on plain :hover meant the panel closed the moment the pointer
   entered the gap between the nav link and the card. That gap is bridged in
   CSS now, but the pointer also travels sideways to reach a panel centred on
   the whole bar, so closing is deliberately delayed: leaving starts a timer
   that re-entering cancels. */
var megaOpen = null, megaTimer = 0;
function megaShow(grp){
  clearTimeout(megaTimer);
  if(megaOpen && megaOpen !== grp) megaOpen.classList.remove('is-open');
  grp.classList.add('is-open');
  megaOpen = grp;
}
function megaHide(){
  clearTimeout(megaTimer);
  if(megaOpen){ megaOpen.classList.remove('is-open'); megaOpen = null; }
}
function megaHideSoon(){
  clearTimeout(megaTimer);
  megaTimer = setTimeout(megaHide, 280);
}
document.addEventListener('mouseover', function(e){
  var t = e.target;
  if(!t || !t.closest) return;
  var it = t.closest('[data-mega-item]');
  if(it) setMegaPreview(it);
  var grp = t.closest('.af-navgroup');
  if(grp) megaShow(grp);
  else if(megaOpen) megaHideSoon();
});
document.addEventListener('focusin', function(e){
  if(!e.target || !e.target.closest) return;
  var it = e.target.closest('[data-mega-item]');
  if(it) setMegaPreview(it);
});
document.addEventListener('keydown', function(e){
  if(e.key !== 'Escape') return;
  megaHide();
  var el = document.activeElement;
  if(el && el.closest && el.closest('.af-navgroup') && el.blur) el.blur();
});

window.addEventListener('hashchange', function(){ transitionRender(function(){ state.menuOpen = false; }, {top:true}); });
(function(){
  if(location.pathname !== '/' || !location.hash || location.hash === '#/') return;
  var dest = realUrl(location.hash);
  if(dest && dest !== location.hash && dest !== '/') location.replace(dest);
})();
render();


/* ---- SEO content from Shopify (window.AFX_PAGE is printed by the Liquid template) ---- */
function afxPage(){ return window.AFX_PAGE || {}; }

function afxOverview(slug){
  var P = afxPage();
  if(P.type !== 'product' || P.handle !== slug || !P.description) return '';
  return '<section class="wrap reveal" style="padding-block:30px 0"><div class="pd-block afx-ovw">'
    +'<h2>'+(t()==='ar' ? 'نظرة عامة' : 'Overview')+'</h2>'+P.description+'</div></section>';
}

/* Collections that are not one of the six disciplines (Pipe Hangers & Clamps,
   Electromechanical Supports) - rendered from the product list Shopify prints. */
function renderCollection(){
  var P = afxPage();
  var c = SOLUTIONS[t()];
  if(P.type !== 'collection' || P.handle !== state.coll) return renderSolutions();
  var tabsHtml = '<button type="button" class="af-tab" data-action="sol-tab" data-cat="all">'+esc(c.allLabel)+'</button>'
    + c.cats.map(function(cat,i){ return '<button type="button" class="af-tab" data-action="sol-tab" data-cat="'+i+'">'+esc(cat.name)+'</button>'; }).join('');
  var items = (P.products || []).map(function(h){ var hit = findProduct(h); return hit ? hit.item : null; })
    .filter(function(x){ return x; });
  return ''
   +'<div class="page-bg">'+renderHeader('products')
   +'<section class="wrap reveal" style="padding-block:72px 0 0"><span class="kicker">'+esc('Solutions')+'</span>'
   +'<h1 style="font-family:var(--font-heading);font-weight:600;font-size:clamp(34px,4.4vw,56px);line-height:1.05;letter-spacing:-.02em;margin:18px 0 0;max-width:20ch">'+esc(P.title||'')+'</h1>'
   +'<div class="afx-colldesc">'+(P.description||'')+'</div></section>'
   +'<div style="position:sticky;top:var(--hdr,71px);z-index:30;background:color-mix(in srgb,var(--color-bg) 88%,transparent);backdrop-filter:blur(10px);border-bottom:1px solid var(--color-divider);margin-top:36px">'
   +'<div class="wrap af-scrollx" style="padding-block:14px;display:flex;gap:10px">'+tabsHtml+'</div></div>'
   +'<section class="wrap reveal" style="padding-block:44px 84px"><div class="grid-4">'+items.map(productTile).join('')+'</div></section>'
   +renderFooter()+'</div>';
}

function projectRefs(list){
  var rows = list.filter(function(p){ return PROJECT_REFS[p.name]; });
  if(!rows.length) return '';
  var ar = t()==='ar';
  var H = ar ? ['المشروع','المالك','الاستشاري','المقاول الرئيسي','السنة'] : ['Project','Owner / client','Consultant','Main contractor','Year'];
  return '<section class="wrap reveal" style="padding-block:0 72px">'
    +'<h2 style="font-size:clamp(22px,2.4vw,28px);letter-spacing:-.02em;margin:0 0 8px">'+(ar ? 'مراجع المشروعات' : 'Project references')+'</h2>'
    +'<p style="font-size:15px;color:var(--color-neutral-300);max-width:64ch;margin:0 0 22px">'
    +(ar ? 'المالك والاستشاري والمقاول الرئيسي وسنة التوريد لكل مشروع.' : 'Owner, consultant, main contractor and year for each project supplied with AFROFIX pipe supports.')+'</p>'
    +'<div class="af-scrollx pd-tablewrap"><table class="pd-table"><thead><tr>'+H.map(function(h){ return '<th>'+esc(h)+'</th>'; }).join('')+'</tr></thead><tbody>'
    + rows.map(function(p){ var r = PROJECT_REFS[p.name];
        return '<tr><td class="pd-pn">'+esc(p.name)+'</td>'+r.map(function(v){ return '<td>'+esc(v||'—')+'</td>'; }).join('')+'</tr>'; }).join('')
    +'</tbody></table></div></section>';
}

function partnerText(kind){
  if(t() === 'ar') return '';
  var names = (kind === 'contractors' ? CONTRACTORS : CONSULTANTS).join(', ');
  var body = kind === 'contractors'
    ? 'These contractors install AFROFIX pipe supports on power plants, metro and monorail lines, hospitals, hotels, stadiums and towers across Egypt. Every product is manufactured in 6th of October City and supplied with load ratings, material traceability and submittal documentation.'
    : 'These engineering and design offices specify AFROFIX supports on their projects. Our products are UL Listed and FM Approved and manufactured under an ISO 9001:2015 quality system, so they can be named in fire-protection, HVAC and plumbing specifications with the documentation to support submittal.';
  return '<section class="wrap reveal" style="padding-block:8px 8px"><p class="afx-partners">'
    + '<strong>' + esc(names) + '.</strong> ' + esc(body) + '</p></section>';
}

function afxCta(){
  return '<section class="wrap reveal" style="padding-block:10px 84px"><div class="card elev-md" style="border-radius:var(--radius-lg);padding:44px;text-align:center;align-items:center;background:radial-gradient(600px 260px at 50% -20%,color-mix(in srgb,var(--color-accent) 16%,transparent),transparent 70%),var(--color-surface)">'
    +'<h2 style="font-size:clamp(24px,2.6vw,32px);letter-spacing:-.02em;margin:0 0 10px;max-width:26ch">Working on a project?</h2>'
    +'<p style="font-size:15px;color:var(--color-neutral-300);max-width:52ch;margin:0 0 24px">Send us your drawings or BOQ and our engineering team will come back with a quotation.</p>'
    +'<a class="btn btn-primary"'+QUOTE_ATTRS+' style="padding:12px 24px;font-size:15px">'+esc(BASE[t()].cta.quote)+'</a></div></section>';
}

/* A Shopify page or blog article (FAQ, service pages, news, technical articles) */
function renderCms(){
  var P = afxPage();
  var crumbs = (P.crumbs || []).map(function(c){ return '<a href="'+c[1]+'">'+esc(c[0])+'</a><span>/</span>'; }).join('');
  var meta = P.date ? '<p class="afx-cms__meta">'+esc(P.date)+(P.author ? ' · '+esc(P.author) : '')+'</p>' : '';
  var hero = P.image ? '<figure class="afx-cms__img"><img src="'+P.image+'" alt="'+esc(P.imageAlt || P.title || '')+'" loading="eager"></figure>' : '';
  return ''
   +'<div class="page-bg">'+renderHeader(P.nav || '')
   +'<section class="wrap reveal" style="padding-block:34px 0"><nav class="pd-crumb">'+crumbs+'<span>'+esc(P.title||'')+'</span></nav></section>'
   +'<section class="wrap reveal" style="padding-block:40px 8px">'
   +(P.kicker ? '<span class="kicker">'+esc(P.kicker)+'</span>' : '')
   +'<h1 class="afx-cms__h1">'+esc(P.title||'')+'</h1>'+meta+'</section>'
   +'<section class="wrap reveal" style="padding-block:18px 56px">'+hero+'<div class="afx-cms">'+(P.html||'')+'</div></section>'
   + afxCta() + renderFooter()+'</div>';
}

/* The News & articles blog index */
function renderBlogList(){
  var P = afxPage();
  var cards = (P.articles || []).map(function(a){
    return '<a class="card elev-sm afx-post" href="'+a.url+'">'
      +(a.image ? '<div class="afx-post__img"><img src="'+a.image+'" alt="'+esc(a.title)+'" loading="lazy"></div>' : '')
      +'<div class="afx-post__body"><p class="afx-cms__meta">'+esc(a.date||'')+'</p><h2>'+esc(a.title)+'</h2>'
      +(a.excerpt ? '<p>'+esc(a.excerpt)+'</p>' : '')+'<span class="afx-post__more">Read more &rarr;</span></div></a>';
  }).join('');
  return ''
   +'<div class="page-bg">'+renderHeader('')
   +'<section class="wrap reveal" style="padding-block:72px 8px"><span class="kicker">News &amp; articles</span>'
   +'<h1 class="afx-cms__h1">'+esc(P.title||'News')+'</h1>'
   +'<p style="font-size:17px;line-height:1.6;color:var(--color-neutral-300);max-width:64ch;margin:18px 0 0">'+esc(P.desc||'')+'</p></section>'
   +'<section class="wrap reveal" style="padding-block:40px 72px">'
   +(cards ? '<div class="afx-posts">'+cards+'</div>' : '<p style="color:var(--color-neutral-300)">New articles are on the way.</p>')
   +'</section>' + afxCta() + renderFooter()+'</div>';
}
